import { useState, useEffect, useCallback, useMemo, useRef } from "react";

var APP_VERSION = "1.16.0";
var APP_BUILD_DATE = "2026-10-14";

/* ── STYLES ── */
const S = {
  app: { width: "100%", minHeight: "100vh", backgroundColor: "#F8F7F4", fontFamily: "'Nunito', sans-serif" },
  loadScreen: { display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", backgroundColor: "#F8F7F4" },
  homeCtr: { minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", padding: "48px 24px 24px", maxWidth: 600, margin: "0 auto" },
  homeHdr: { textAlign: "center", marginBottom: 40 },
  homeGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, width: "100%" },
  homeBtn: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "24px 16px", borderRadius: 20, border: "none", cursor: "pointer", transition: "all .15s", minHeight: 120 },
  kCtr: { display: "flex", flexDirection: "column", backgroundColor: "#F8F7F4", maxWidth: 700, margin: "0 auto" },
  kHdr: { display: "flex", alignItems: "center", padding: 16, color: "#fff", borderRadius: "0 0 24px 24px" },
  kBack: { background: "rgba(255,255,255,.2)", border: "none", color: "#fff", padding: "8px 14px", borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "'Nunito', sans-serif" },
  prog: { display: "flex", gap: 4, padding: "12px 16px" },
  kBody: {},
  nBtn: { width: "100%", padding: 16, border: "none", borderRadius: 16, color: "#fff", fontSize: 17, fontWeight: 800, cursor: "pointer", fontFamily: "'Fredoka', sans-serif", transition: "all .15s" },
  iCtr: { minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#F8F7F4", maxWidth: 700, margin: "0 auto" },
  sHdr: { padding: "16px 16px 8px" },
  tRow: { display: "flex", gap: 6, padding: "0 16px", marginBottom: 12 },
  tab: { flex: 1, padding: "10px 12px", borderRadius: 12, border: "none", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "'Nunito', sans-serif", transition: "all .15s" },
  sIn: { width: "100%", padding: "10px 14px", borderRadius: 12, border: "2px solid #e5e7eb", fontSize: 16, fontFamily: "'Nunito', sans-serif", outline: "none", backgroundColor: "#fff" },
  bBtn: { flex: 1, padding: "8px 12px", borderRadius: 10, border: "none", fontSize: 13, fontWeight: 700, cursor: "pointer", backgroundColor: "#D1FAE5", color: "#065F46", fontFamily: "'Nunito', sans-serif" },
  back: { background: "none", border: "none", fontSize: 15, fontWeight: 700, color: "#888", cursor: "pointer", padding: "4px 0", marginBottom: 4, fontFamily: "'Nunito', sans-serif" },
  cLbl: { fontSize: 13, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8, fontFamily: "'Nunito', sans-serif" },
  dCtr: { minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#F8F7F4", maxWidth: 700, margin: "0 auto" },
  sCtr: { minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#F8F7F4", maxWidth: 700, margin: "0 auto" },
  sLbl: { fontSize: 13, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 6, fontFamily: "'Nunito', sans-serif" },
  sInput: { width: "100%", padding: "10px 14px", borderRadius: 12, border: "2px solid #e5e7eb", fontSize: 16, fontFamily: "'Nunito', sans-serif", outline: "none" },
  step: { width: 36, height: 36, borderRadius: "50%", border: "2px solid #e5e7eb", backgroundColor: "#fff", fontSize: 18, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  mini: { padding: "4px 10px", borderRadius: 8, border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'Nunito', sans-serif", whiteSpace: "nowrap" },
};

const CSS = "@import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap');*{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}html,body{touch-action:pan-x pan-y;-webkit-text-size-adjust:100%;overscroll-behavior:none;}button,input,select,textarea,[role=\"button\"]{touch-action:manipulation;}";

function BFLogo({ size }) {
  var w = size || 64;
  var h = w * 0.708;
  return (<img src="data:image/png;base64,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" width={w} height={h} alt="BentoFam" style={{ display: "block" }} />);
}

/* ── CONSTANTS ── */
const DEF_KIDS = [
  { id: "kid1", name: "Kid 1", emoji: "🦊", color: "#FF6B6B", image: null },
  { id: "kid2", name: "Kid 2", emoji: "🐸", color: "#4ECDC4", image: null },
  { id: "kid3", name: "Kid 3", emoji: "🦋", color: "#A78BFA", image: null },
];

const DEF_MENU = {
  Breakfast: {
    Bagel: [{ name: "Bagel plain", available: true }, { name: "Bagel with Butter", available: true }, { name: "O'bagel bagel", available: true }],
    Cereal: [{ name: "Captain Crunch", available: false }, { name: "Honey Bunches", available: true }, { name: "Honey Nut Cheerios", available: true }, { name: "Life Cereal", available: true }, { name: "Mini Wheats", available: true }, { name: "Oatmeal", available: true }],
    Eggs: [{ name: "Hard Boiled", available: false }, { name: "Scrambled", available: true }],
    Pancakes: [{ name: "Pancake", available: true }, { name: "Mini pancakes", available: true }],
    Toast: [{ name: "Cinnamon Toast", available: false }, { name: "Cinnamon Raisin Toast", available: true }],
    Waffle: [{ name: "Chocolate Chip Waffle", available: false, special: true }, { name: "Waffle only", available: true }, { name: "Waffle with Eggs", available: true }, { name: "Waffle with Sausage", available: true }, { name: "Protein Waffle", available: true }],
    Yogurt: [{ name: "Frozen Blueberry", available: false }, { name: "Frozen Strawberry", available: false }, { name: "Gogurt", available: false }],
  },
  Lunch: {
    Meats: [{ name: "Chicken Nuggets", available: true }, { name: "Dino Nuggets", available: true }],
    Mexican: [{ name: "Leftover taco meat", available: true }, { name: "Quesadilla", available: true }],
    Pasta: [{ name: "Annie's Mac & Cheese", available: false }, { name: "Kraft Mac & Cheese", available: false }, { name: "Pasta & Meatballs", available: false }, { name: "Ravioli & Meatballs", available: false }],
    Pizza: [{ name: "Pizza (White)", available: false }, { name: "Pizza (Plain)", available: false }, { name: "Pizza Bagels", available: true }],
    Sandwich: [{ name: "Sebbys special", available: false }, { name: "Crackers & Cheese", available: true }, { name: "PB&J on bread", available: true }, { name: "PB&J on crackers", available: true }],
    Yogurt: [{ name: "Frozen Blueberry", available: false }, { name: "Gogurt", available: false }],
  },
  Snacks: {
    "Fruits & Veggies": [{ name: "Oranges", available: false }, { name: "Apple Sauce", available: true }, { name: "Blueberries", available: true }, { name: "Carrots", available: true }, { name: "Cucumbers", available: true }, { name: "Strawberries", available: true }],
    Salty: [{ name: "Saltine Crackers", available: false }, { name: "P.B. pretzels", available: true }, { name: "Pretzels", available: true }, { name: "Regular Popcorn", available: true }, { name: "Wheat Thins", available: true }],
    Savory: [{ name: "Cheese Crackers", available: true }, { name: "Cheese-itz", available: true }, { name: "Goldfish", available: true }, { name: "Goldfish Colors", available: true }],
    Sweet: [{ name: "Belvita Bar", available: true }, { name: "Costco Bar", available: true }, { name: "Graham Crackers", available: true }, { name: "Granola Bar", available: true }, { name: "Z-Bar", available: true }],
  },
};

const DEF_RULES = { breakfastCount: 1, lunchCount: 1, snackCount: 3, minFruitVeggie: 1, maxSweet: 1, noRepeatBreakfast: false, noRepeatBreakfastDays: 3, noRepeatLunch: false, noRepeatLunchDays: 3, noRepeatSnacks: false, noRepeatSnacksDays: 3, sortOrder: "alpha" };
const DEF_NOTIF = { notifyPerKid: true, soundEnabled: true, haEnabled: false, haUrl: "" };
const DEF_SET = { password: "", dayEnabled: false, specialDay: false };
const DEF_CAL = { dates: [], lunchProvided: [], afterSchool: [] };
// Extra snack picked on activity days, packed separately from the three school snacks
var AFTER_SCHOOL_COUNT = 1;

const EMOJIS = {
  "🦊": "Fox", "🐸": "Frog", "🦋": "Butterfly", "🐶": "Dog", "🐱": "Cat", "🦁": "Lion", "🐼": "Panda", "🐨": "Koala",
  "🦄": "Unicorn", "🐙": "Octopus", "🦖": "Dinosaur", "🐝": "Bee", "🐬": "Dolphin", "🦜": "Parrot", "🐢": "Turtle", "🐰": "Bunny",
  "🐯": "Tiger", "🐮": "Cow", "🐷": "Pig", "🐵": "Monkey", "🦈": "Shark", "🦩": "Flamingo", "🦥": "Sloth", "🦧": "Orangutan",
  "🐺": "Wolf", "🦇": "Bat", "🦉": "Owl", "🐴": "Horse", "🐲": "Dragon", "🐾": "Paw Print", "🌈": "Rainbow", "⭐": "Star",
  "🔥": "Fire", "💎": "Diamond", "🎮": "Game", "⚽": "Soccer", "🏀": "Basketball", "🎸": "Guitar", "🎨": "Art", "🚀": "Rocket",
  "👑": "Crown", "🎯": "Bullseye", "🍕": "Pizza Slice", "🌮": "Taco", "🍩": "Donut", "🧁": "Cupcake", "🍪": "Cookie", "🎂": "Cake",
  "🌸": "Cherry Blossom", "🌻": "Sunflower", "🌺": "Hibiscus", "🍀": "Four Leaf Clover", "🌙": "Crescent Moon", "☀️": "Sun",
  "❄️": "Snowflake", "🌊": "Wave", "🎵": "Music Note", "🎭": "Theater", "🎪": "Circus", "🎠": "Carousel", "🏰": "Castle",
  "🧸": "Teddy Bear", "🎀": "Ribbon", "🪄": "Magic Wand", "🐞": "Ladybug", "🐛": "Bug", "🐠": "Tropical Fish",
  "🦑": "Squid", "🦀": "Crab", "🐊": "Crocodile", "🦎": "Lizard", "🐍": "Snake", "🦅": "Eagle", "🦆": "Duck", "🦢": "Swan",
  "🦌": "Deer", "🐘": "Elephant", "🦒": "Giraffe", "🦓": "Zebra", "🦍": "Gorilla", "🐻": "Bear", "🐧": "Penguin", "🐥": "Baby Chick",
  "🌵": "Cactus", "🌲": "Evergreen Tree", "🍄": "Mushroom", "🍓": "Strawberry", "🍒": "Cherry", "🥑": "Avocado", "🍋": "Lemon",
  "⚡": "Lightning", "💫": "Dizzy Star", "✨": "Sparkles", "💖": "Sparkling Heart", "💜": "Purple Heart", "💙": "Blue Heart",
  "💚": "Green Heart", "🧡": "Orange Heart", "💛": "Yellow Heart", "🤍": "White Heart", "🖤": "Black Heart",
  "⛰️": "Mountain", "🏔️": "Snow Mountain", "🌋": "Volcano", "🏖️": "Beach", "🎃": "Jack-O-Lantern", "🎄": "Christmas Tree",
  "☘️": "Shamrock", "✝️": "Cross", "⚓": "Anchor", "🛡️": "Shield", "🏆": "Trophy", "🥇": "Gold Medal",
};
const EMOJI_LIST = Object.keys(EMOJIS);
const COLORS = {
  "#FF6B6B": "Coral", "#4ECDC4": "Teal", "#A78BFA": "Lavender", "#F59E0B": "Amber", "#10B981": "Emerald",
  "#3B82F6": "Blue", "#EC4899": "Pink", "#8B5CF6": "Purple", "#EF4444": "Red", "#06B6D4": "Cyan",
  "#84CC16": "Lime", "#F97316": "Orange", "#14B8A6": "Mint", "#6366F1": "Indigo", "#D946EF": "Fuchsia",
  "#0EA5E9": "Sky Blue", "#F43F5E": "Rose", "#78716C": "Stone", "#1a1a2e": "Navy", "#92400E": "Brown",
  "#059669": "Forest", "#7C3AED": "Violet", "#DB2777": "Magenta", "#CA8A04": "Gold",
};
const COLOR_LIST = Object.keys(COLORS);
const SK = { menu: "mm2-menu", kids: "mm2-kids", rules: "mm2-rules", hist: "mm2-hist", today: "mm2-today", notif: "mm2-notif", set: "mm2-set", cal: "mm2-cal" };
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

/* ── HELPERS ── */
import { sGet, sSet } from "./firebase";
function localDateStr(d) { return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"); }
function today() { return localDateStr(orderDate()); }
function realToday() { return localDateStr(new Date()); }
function orderDate() {
  var now = new Date();
  if (now.getHours() >= 8) {
    var tom = new Date(now);
    tom.setDate(tom.getDate() + 1);
    return tom;
  }
  return now;
}
// Everything in a today/selections snapshot is stale if it was stamped with a previous ordering date
function freshTs(t) { return t && t._date === today() ? t : {}; }
// Fire-and-forget saves log here instead of surfacing as unhandled rejections
function logSaveFail(what) { return function (e) { console.error(what + " save failed", e); }; }

/* ── TRUSTED DEVICES ── */
// Trust lives only in this device's localStorage, never in Firestore.
var TRUST_KEY = "bf_parent_trust";
var TRUST_DAYS = 30;

function trustToken(pw) {
  // Non-secret fingerprint of the PIN so a PIN change invalidates all trusted devices.
  var h = 0;
  for (var i = 0; i < pw.length; i++) { h = ((h << 5) - h + pw.charCodeAt(i)) | 0; }
  return "t" + Math.abs(h);
}
function readTrust() {
  try { var raw = window.localStorage.getItem(TRUST_KEY); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
}
function isTrusted(pw) {
  if (!pw) return true;
  var t = readTrust();
  return !!(t && t.token === trustToken(pw) && t.until > Date.now());
}
function trustUntil() { var t = readTrust(); return t && t.until ? t.until : null; }
// The kiosk iPad must never become trusted by accident: trust is granted only
// by typing the PIN into PwGate or opening a ?unlock= link on that device.
// Nothing on the Home screen or kiosk flow may call this.
function trustDevice(pw) {
  try { window.localStorage.setItem(TRUST_KEY, JSON.stringify({ token: trustToken(pw), until: Date.now() + TRUST_DAYS * 86400000 })); } catch (e) {}
}
function forgetDevice() { try { window.localStorage.removeItem(TRUST_KEY); } catch (e) {} }
function fTime(d) { return new Date(d).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }); }
function orderDateLabel() {
  var d = orderDate();
  var now = new Date();
  if (d.getDate() === now.getDate() && d.getMonth() === now.getMonth()) {
    return "Today, " + d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
  }
  return "Tomorrow, " + d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
}
function fmtYmd(ymd) {
  // "2026-09-16" -> "Wed, Sep 16"
  var p = ymd.split("-");
  var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
  return d.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
}
function fmtMd(md) {
  // "09-16" -> "Sep 16"
  var p = md.split("-");
  var d = new Date(2000, parseInt(p[0], 10) - 1, parseInt(p[1], 10));
  return d.toLocaleDateString([], { month: "short", day: "numeric" });
}
function ymdOf(y, m, d) { return y + "-" + String(m).padStart(2, "0") + "-" + String(d).padStart(2, "0"); }
// null when not a special day; { label: null } for the manual toggle; { label } when
// a special date (MM-DD, annual) matches the ordering date
function specDayInfo(cal, manual) {
  if (manual) return { label: null };
  var d = orderDate();
  var md = String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  var dates = (cal && cal.dates) || [];
  for (var i = 0; i < dates.length; i++) {
    var entry = dates[i];
    var dateStr = typeof entry === "string" ? entry : entry.date;
    if (dateStr === md) return { label: (typeof entry === "string" ? "" : entry.label) || "" };
  }
  return null;
}
function isSpecDay(cal, manual) { return !!specDayInfo(cal, manual); }
function effMenu(menu, spec) {
  var e = JSON.parse(JSON.stringify(menu));
  Object.keys(e).forEach(function (mt) {
    Object.keys(e[mt]).forEach(function (cat) {
      e[mt][cat] = e[mt][cat].filter(function (it) {
        if (it.special) return spec && it.available;
        return it.available;
      });
    });
  });
  return e;
}
function deepClone(o) { return JSON.parse(JSON.stringify(o)); }
// Lunch-provided entry for a kid on the current ordering date, or null.
// lunchProvided dates are full YYYY-MM-DD (migrated on load from legacy MM-DD).
function lunchProvidedFor(calendar, kidId) {
  if (!calendar || !calendar.lunchProvided) return null;
  var td = today();
  return calendar.lunchProvided.find(function (lp) {
    if (lp.date !== td) return false;
    if (!lp.kids || !lp.kids.length) return true; // empty = all kids
    return lp.kids.indexOf(kidId) >= 0;
  }) || null;
}
// After-school activity entry for a kid on the current ordering date, or null
function afterSchoolFor(calendar, kidId) {
  if (!calendar || !calendar.afterSchool) return null;
  var td = today();
  return calendar.afterSchool.find(function (a) {
    if (a.date !== td) return false;
    if (!a.kids || !a.kids.length) return true;
    return a.kids.indexOf(kidId) >= 0;
  }) || null;
}

/* ── RULES ── */
// Snacks are a max (1..snackCount): this only blocks over-max sweets and repeats.
// The fruit/veggie minimum is enforced by the kiosk at Next, not by blocking chips.
function snackRules(sel, menu, rules, hist) {
  var warn = [], blocked = new Set(), cc = {};
  sel.forEach(function (item) {
    Object.keys(menu.Snacks).forEach(function (cat) {
      if (menu.Snacks[cat].some(function (i) { return i.name === item; })) cc[cat] = (cc[cat] || 0) + 1;
    });
  });
  if (rules.maxSweet > 0 && (cc["Sweet"] || 0) >= rules.maxSweet) {
    (menu.Snacks["Sweet"] || []).forEach(function (i) { if (sel.indexOf(i.name) < 0) blocked.add(i.name); });
  }
  var rem = rules.snackCount - sel.length;
  // No-repeat rule — only block if picked N days in a ROW
  var repeatBlocked = new Set();
  if (rules.noRepeatSnacks && rules.noRepeatSnacksDays > 0 && hist) {
    repeatBlocked = getConsecutiveRepeats(hist, "snacks", rules.noRepeatSnacksDays);
  }
  // Deadlock check: if blocking repeats would leave no selectable items, relax the rule
  var allAvail = [];
  Object.keys(menu.Snacks).forEach(function (cat) { menu.Snacks[cat].forEach(function (i) { if (sel.indexOf(i.name) < 0 && !blocked.has(i.name)) allAvail.push(i.name); }); });
  var wouldRemain = allAvail.filter(function (name) { return !repeatBlocked.has(name); });
  if (wouldRemain.length >= rem) {
    repeatBlocked.forEach(function (s) { blocked.add(s); });
  } else {
    warn.push("Repeat rule relaxed — not enough choices otherwise!");
  }
  return { warn: warn, blocked: blocked };
}
// Returns items picked on each of the N consecutive calendar days immediately
// before the current ordering date. A skipped day breaks the streak.
function getConsecutiveRepeats(hist, mealKey, n) {
  if (!hist || hist.length === 0 || n <= 0) return new Set();
  var byDate = {};
  hist.forEach(function (e) { byDate[e.date] = e; });
  var candidates = null;
  var d = orderDate();
  for (var i = 0; i < n; i++) {
    d.setDate(d.getDate() - 1);
    var entry = byDate[localDateStr(d)];
    if (!entry) return new Set();
    var dayItems = new Set(entry[mealKey] || []);
    if (candidates === null) { candidates = dayItems; }
    else {
      var next = new Set();
      candidates.forEach(function (item) { if (dayItems.has(item)) next.add(item); });
      candidates = next;
    }
  }
  return candidates || new Set();
}

function mealRules(sel, mt, rules, hist) {
  var blocked = new Set();
  var key = mt === "Breakfast" ? "noRepeatBreakfast" : "noRepeatLunch";
  var daysKey = key + "Days";
  if (rules[key] && rules[daysKey] > 0 && hist) {
    var streakBlocked = getConsecutiveRepeats(hist, mt.toLowerCase(), rules[daysKey]);
    streakBlocked.forEach(function (i) { if (sel.indexOf(i) < 0) blocked.add(i); });
  }
  return { blocked: blocked };
}

/* ── SOUNDS ── */
function playOk() { try { var c = new (window.AudioContext || window.webkitAudioContext)(); [523, 659, 784, 1047].forEach(function (f, i) { var o = c.createOscillator(), g = c.createGain(); o.connect(g); g.connect(c.destination); o.frequency.value = f; o.type = "sine"; g.gain.setValueAtTime(.15, c.currentTime + i * .15); g.gain.exponentialRampToValueAtTime(.001, c.currentTime + i * .15 + .4); o.start(c.currentTime + i * .15); o.stop(c.currentTime + i * .15 + .4); }); } catch (e) {} }
function playTap() { try { var c = new (window.AudioContext || window.webkitAudioContext)(), o = c.createOscillator(), g = c.createGain(); o.connect(g); g.connect(c.destination); o.frequency.value = 800; o.type = "sine"; g.gain.setValueAtTime(.08, c.currentTime); g.gain.exponentialRampToValueAtTime(.001, c.currentTime + .08); o.start(); o.stop(c.currentTime + .08); } catch (e) {} }

/* ── NOTIFICATIONS ── */
async function haSend(url, wh, data) {
  if (!url) return false;
  try {
    var r = await fetch(url.replace(/\/+$/, "") + "/api/webhook/" + wh, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) });
    return r.ok;
  } catch (e) { console.error("haSend failed", wh, e); return false; }
}

/* ── SMALL COMPONENTS ── */

// Sort items within a category based on kid's usage history
function sortItems(items, kidHist, sortOrder) {
  if (!sortOrder || sortOrder === "alpha" || !kidHist || !kidHist.length) {
    return items.slice().sort(function (a, b) { return a.name.localeCompare(b.name); });
  }
  var cutoff = null;
  if (sortOrder === "30day") {
    var d = new Date(); d.setDate(d.getDate() - 30);
    cutoff = localDateStr(d);
  }
  var counts = {};
  kidHist.forEach(function (entry) {
    if (cutoff && entry.date < cutoff) return;
    ["breakfast", "lunch", "snacks"].forEach(function (mt) {
      (entry[mt] || []).forEach(function (name) { counts[name] = (counts[name] || 0) + 1; });
    });
  });
  return items.slice().sort(function (a, b) {
    var ca = counts[a.name] || 0, cb = counts[b.name] || 0;
    if (cb !== ca) return cb - ca;
    return a.name.localeCompare(b.name);
  });
}

// Check if item is flagged as new (newUntil is in the future)
function isNewItem(item) {
  if (!item.newUntil) return false;
  return new Date(item.newUntil) >= new Date();
}

// Sort categories by aggregate usage for a kid
function sortCategories(catNames, section, kidHist, sortOrder) {
  if (!sortOrder || sortOrder === "alpha" || !kidHist || !kidHist.length) {
    return catNames.slice().sort(function (a, b) { return a.localeCompare(b); });
  }
  var cutoff = null;
  if (sortOrder === "30day") {
    var d = new Date(); d.setDate(d.getDate() - 30);
    cutoff = localDateStr(d);
  }
  var counts = {};
  kidHist.forEach(function (entry) {
    if (cutoff && entry.date < cutoff) return;
    ["breakfast", "lunch", "snacks"].forEach(function (mt) {
      (entry[mt] || []).forEach(function (name) { counts[name] = (counts[name] || 0) + 1; });
    });
  });
  var catCounts = {};
  catNames.forEach(function (cat) {
    var total = 0;
    (section[cat] || []).forEach(function (i) { total += counts[i.name] || 0; });
    catCounts[cat] = total;
  });
  return catNames.slice().sort(function (a, b) {
    if (catCounts[b] !== catCounts[a]) return catCounts[b] - catCounts[a];
    return a.localeCompare(b);
  });
}
function Confetti({ active }) {
  if (!active) return null;
  var pcs = [], cols = ["#FF6B6B", "#4ECDC4", "#A78BFA", "#F59E0B", "#10B981", "#3B82F6", "#EC4899"];
  for (var i = 0; i < 40; i++) pcs.push({ id: i, l: Math.random() * 100, d: Math.random() * .5, c: cols[i % 7], sz: 6 + Math.random() * 8, r: Math.random() * 360 });
  return (<div style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 9999 }}>
    {pcs.map(function (p) { return <div key={p.id} style={{ position: "absolute", left: p.l + "%", top: -20, width: p.sz, height: p.sz, backgroundColor: p.c, borderRadius: p.sz > 10 ? "50%" : "2px", transform: "rotate(" + p.r + "deg)", animation: "cfall 2s " + p.d + "s ease-in forwards" }} />; })}
    <style>{"@keyframes cfall{0%{transform:translateY(0) rotate(0);opacity:1}100%{transform:translateY(100vh) rotate(720deg);opacity:0}}"}</style>
  </div>);
}

function Avatar({ kid, size, showCheck, checked }) {
  var sz = size || 64;
  return (<div style={{ position: "relative", width: sz, height: sz }}>
    <div style={{ width: sz, height: sz, borderRadius: "50%", overflow: "hidden", backgroundColor: kid.color + "20", display: "flex", alignItems: "center", justifyContent: "center", fontSize: sz * .5, border: "3px solid " + kid.color + "40" }}>
      {kid.image ? <img src={kid.image} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : kid.emoji}
    </div>
    {showCheck && checked && <div style={{ position: "absolute", bottom: -2, right: -2, width: sz * .35, height: sz * .35, borderRadius: "50%", backgroundColor: "#10B981", border: "2px solid #fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: sz * .18, color: "#fff", fontWeight: 800 }}>✓</div>}
  </div>);
}

function Tog({ label, value, onToggle }) {
  return (<button onClick={onToggle} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: "14px 16px", marginBottom: 6, borderRadius: 12, border: "none", backgroundColor: "#fff", cursor: "pointer" }}>
    <span style={{ fontSize: 15, fontWeight: 600, color: "#374151", fontFamily: "'Nunito', sans-serif" }}>{label}</span>
    <div style={{ width: 44, height: 26, borderRadius: 13, backgroundColor: value ? "#10B981" : "#d1d5db", position: "relative", transition: "background-color .2s" }}>
      <div style={{ position: "absolute", top: 3, left: value ? 21 : 3, width: 20, height: 20, borderRadius: "50%", backgroundColor: "#fff", transition: "left .2s", boxShadow: "0 1px 3px rgba(0,0,0,.2)" }} />
    </div>
  </button>);
}

function PwGate({ pw, children, onBack }) {
  const [inp, setInp] = useState("");
  const [err, setErr] = useState(false);
  const [ok, setOk] = useState(isTrusted(pw));
  if (!pw || ok) return <>{children}</>;
  function go() { if (inp === pw) { trustDevice(pw); setOk(true); setErr(false); } else { setErr(true); setInp(""); } }
  return (<div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "#F8F7F4", padding: 24 }}>
    <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
    <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e", marginBottom: 8 }}>Parent Access</div>
    <input type="password" value={inp} onChange={function (e) { setInp(e.target.value); setErr(false); }} onKeyDown={function (e) { if (e.key === "Enter") go(); }} placeholder="Password" autoFocus style={{ ...S.sInput, maxWidth: 260, textAlign: "center", fontSize: 18, marginBottom: 12 }} />
    {err && <div style={{ color: "#DC2626", fontSize: 14, fontWeight: 600, marginBottom: 8 }}>Wrong password</div>}
    <div style={{ fontSize: 13, color: "#888", marginBottom: 16, fontFamily: "'Nunito', sans-serif" }}>This device will stay unlocked for 30 days.</div>
    <div style={{ display: "flex", gap: 10 }}>
      <button onClick={go} style={{ ...S.nBtn, width: "auto", padding: "12px 32px", backgroundColor: "#1a1a2e" }}>Unlock</button>
      <button onClick={onBack} style={{ ...S.nBtn, width: "auto", padding: "12px 24px", backgroundColor: "#e5e7eb", color: "#374151" }}>Back</button>
    </div>
  </div>);
}

function Chip({ label, sel, dis, blk, spec, isNew, hasPB, onClick }) {
  const [p, setP] = useState(false);
  return (<button onClick={onClick} onPointerDown={function () { if (!dis) setP(true); }} onPointerUp={function () { setP(false); }} onPointerLeave={function () { setP(false); }} disabled={dis}
    style={{ padding: "12px 20px", borderRadius: 16, border: sel ? "2.5px solid #10B981" : spec ? "2px solid #F59E0B" : isNew ? "2px solid #3B82F6" : "2px solid #e5e7eb", backgroundColor: sel ? "#D1FAE5" : spec ? "#FFFBEB" : isNew ? "#EFF6FF" : dis ? "#f9fafb" : "#fff", color: sel ? "#065F46" : dis ? "#ccc" : "#374151", fontSize: 16, fontWeight: sel ? 700 : 500, cursor: dis ? "not-allowed" : "pointer", transition: "all .15s", transform: p ? "scale(.95)" : "scale(1)", fontFamily: "'Nunito', sans-serif", textDecoration: blk ? "line-through" : "none", opacity: dis ? .5 : 1 }}>
    {sel && "✓ "}{spec && "✨ "}{isNew && !sel && "🆕 "}{hasPB && "🥜 "}{label}
  </button>);
}

function RuleChip({ label, met, warn, icon }) {
  return (<div style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "6px 12px", borderRadius: 20, fontSize: 13, fontWeight: 600, backgroundColor: met ? "#D1FAE5" : warn ? "#FEF3C7" : "#F3F4F6", color: met ? "#065F46" : warn ? "#92400E" : "#6B7280", fontFamily: "'Nunito', sans-serif" }}>
    {icon} {label} {met && "✓"}
  </div>);
}

var MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var WEEKDAY_LABELS = ["S", "M", "T", "W", "T", "F", "S"];

function daysInMonth(year, monthIdx) {
  return new Date(year, monthIdx + 1, 0).getDate();
}

// onPick(year, month 1-12, day). isSelected/isMarked are optional and receive
// "YYYY-MM-DD" per cell. disablePast greys out and disables days before today.
function MiniCalendar({ onPick, accent, isSelected, isMarked, disablePast }) {
  var now = new Date();
  const [viewYear, setViewYear] = useState(now.getFullYear());
  const [viewMonth, setViewMonth] = useState(now.getMonth());
  var ac = accent || "#10B981";
  var todayYmd = realToday();

  function prevMonth() {
    if (viewMonth === 0) { setViewMonth(11); setViewYear(viewYear - 1); }
    else setViewMonth(viewMonth - 1);
  }
  function nextMonth() {
    if (viewMonth === 11) { setViewMonth(0); setViewYear(viewYear + 1); }
    else setViewMonth(viewMonth + 1);
  }

  var firstDow = new Date(viewYear, viewMonth, 1).getDay();
  var dim = daysInMonth(viewYear, viewMonth);
  var cells = [];
  for (var b = 0; b < firstDow; b++) cells.push(null);
  for (var d = 1; d <= dim; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  var navBtn = { width: 44, height: 44, borderRadius: 10, border: "none", backgroundColor: "#f3f4f6", fontSize: 20, fontWeight: 700, cursor: "pointer", color: "#374151" };

  return (
    <div style={{ backgroundColor: "#fff", borderRadius: 12, padding: 12, border: "2px solid #e5e7eb" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
        <button onClick={prevMonth} style={navBtn}>‹</button>
        <div style={{ fontSize: 15, fontWeight: 700, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{MONTH_NAMES[viewMonth]} {viewYear}</div>
        <button onClick={nextMonth} style={navBtn}>›</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2, marginBottom: 4 }}>
        {WEEKDAY_LABELS.map(function (w, i) {
          return <div key={i} style={{ textAlign: "center", fontSize: 11, fontWeight: 700, color: "#9ca3af", padding: "4px 0" }}>{w}</div>;
        })}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 }}>
        {cells.map(function (c, i) {
          if (c === null) return <div key={i} style={{ aspectRatio: "1 / 1" }} />;
          var ymd = ymdOf(viewYear, viewMonth + 1, c);
          var isToday = ymd === todayYmd;
          var sel = !!(isSelected && isSelected(ymd));
          var past = !!(disablePast && ymd < todayYmd);
          var marked = !sel && !past && !!(isMarked && isMarked(ymd));
          return (
            <button key={i} disabled={past} onClick={function () { if (!past) onPick(viewYear, viewMonth + 1, c); }}
              style={{ aspectRatio: "1 / 1", position: "relative", border: sel || isToday ? "2px solid " + ac : "1px solid transparent", backgroundColor: sel ? ac : isToday ? ac + "15" : "transparent", borderRadius: 8, fontSize: 14, fontWeight: sel || isToday ? 800 : 600, color: sel ? "#fff" : isToday ? ac : "#374151", cursor: past ? "default" : "pointer", opacity: past ? 0.35 : 1, fontFamily: "'Nunito', sans-serif", padding: 0 }}>
              {c}
              {marked && <div style={{ position: "absolute", left: "50%", bottom: 3, width: 5, height: 5, marginLeft: -2.5, borderRadius: "50%", backgroundColor: ac }} />}
            </button>
          );
        })}
      </div>
    </div>
  );
}

// Three-question add form shared by free lunch days and special days.
// dateMode "ymd" returns full dates; "md" returns annual MM-DD dates.
// onAdd(dates, label, kidIds) — dates sorted; kidIds [] means all kids.
// defaultAllKids false starts with nobody selected (Add stays disabled until
// someone is). repeat true adds a weekly "repeat until" expander (ymd mode only).
function CalendarForm({ kids, dateMode, existing, disablePast, labelPlaceholder, noun, accent, onAdd, defaultAllKids, repeat }) {
  const [selected, setSelected] = useState([]);
  const [label, setLabel] = useState("");
  const [allKids, setAllKids] = useState(defaultAllKids !== false);
  const [selKids, setSelKids] = useState([]);
  const [added, setAdded] = useState(false);
  const [repeatOn, setRepeatOn] = useState(false);
  const [until, setUntil] = useState("");
  var ac = accent || "#10B981";
  var md = dateMode === "md";
  var ex = existing || [];
  var fmt = md ? fmtMd : fmtYmd;
  var weekly = !!(repeat && !md && repeatOn);

  // Each selected date plus every +7 days while <= until (60 per seed), deduped
  // and sorted. Local Date math only — never toISOString.
  function expandWeekly(dates) {
    if (!weekly || !until) return dates.slice().sort();
    var out = {};
    dates.forEach(function (seed) {
      var p = seed.split("-");
      var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
      for (var n = 0; n < 60; n++) {
        var k = ymdOf(d.getFullYear(), d.getMonth() + 1, d.getDate());
        if (k > until) break;
        out[k] = true;
        d.setDate(d.getDate() + 7);
      }
    });
    return Object.keys(out).sort();
  }

  function keyOf(ymd) { return md ? ymd.slice(5) : ymd; }
  function pick(y, m, d) {
    var k = keyOf(ymdOf(y, m, d));
    setSelected(function (prev) {
      if (prev.indexOf(k) >= 0) return prev.filter(function (x) { return x !== k; });
      return prev.concat([k]).sort();
    });
  }
  function unpick(k) { setSelected(function (prev) { return prev.filter(function (x) { return x !== k; }); }); }
  function isSel(ymd) { return selected.indexOf(keyOf(ymd)) >= 0; }
  function isMk(ymd) { return ex.indexOf(keyOf(ymd)) >= 0; }
  function togKid(id) {
    setSelKids(function (prev) {
      if (prev.indexOf(id) >= 0) return prev.filter(function (k) { return k !== id; });
      return prev.concat([id]);
    });
  }
  var expanded = weekly ? expandWeekly(selected) : selected;
  var whoOk = !kids || allKids || selKids.length > 0;
  var canAdd = expanded.length > 0 && whoOk && (!weekly || !!until);

  function add() {
    if (!canAdd) return;
    onAdd(expanded.slice(), label.trim(), allKids ? [] : selKids.slice());
    setSelected([]); setLabel(""); setAllKids(defaultAllKids !== false); setSelKids([]);
    setRepeatOn(false); setUntil("");
    setAdded(true);
    setTimeout(function () { setAdded(false); }, 1500);
  }

  var btnText = expanded.length > 1 ? "Add " + expanded.length + " " + noun + "s" : "Add " + noun;
  var repeatPreview = !until ? "Pick an until date" : expanded.length === 0 ? "Tap a day above" : "Will add " + expanded.length + " date" + (expanded.length === 1 ? "" : "s") + ", " + fmtYmd(expanded[0]) + " to " + fmtYmd(expanded[expanded.length - 1]);
  var kidChip = { minHeight: 44, padding: "8px 14px", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "'Nunito', sans-serif" };

  return (
    <div>
      <label style={S.sLbl}>What day?</label>
      <MiniCalendar onPick={pick} accent={ac} isSelected={isSel} isMarked={isMk} disablePast={disablePast} />
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8, marginBottom: 14, minHeight: 28, alignItems: "center" }}>
        {selected.length === 0 && <span style={{ fontSize: 13, color: "#999" }}>Tap a day above</span>}
        {selected.map(function (k) {
          return <button key={k} onClick={function () { unpick(k); }} style={{ padding: "6px 12px", borderRadius: 10, border: "2px solid " + ac, backgroundColor: ac + "15", color: "#1a1a2e", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "'Nunito', sans-serif" }}>{fmt(k)} ✕</button>;
        })}
      </div>

      {repeat && !md && <div style={{ marginBottom: 14 }}>
        <Tog label="🔁 Repeat every week" value={repeatOn} onToggle={function () { setRepeatOn(!repeatOn); }} />
        {repeatOn && <div style={{ padding: "0 4px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>until</span>
            <input type="date" value={until} min={selected.length ? selected[0] : realToday()} onChange={function (e) { setUntil(e.target.value); }} style={{ ...S.sInput, flex: 1, fontSize: 16 }} />
          </div>
          <div style={{ fontSize: 12, color: "#888", marginTop: 6 }}>{repeatPreview}</div>
        </div>}
      </div>}

      <label style={S.sLbl}>What is it for?</label>
      <input type="text" value={label} onChange={function (e) { setLabel(e.target.value); }} placeholder={labelPlaceholder} style={{ ...S.sInput, marginBottom: 14 }} />

      {kids && <div style={{ marginBottom: 14 }}>
        <label style={S.sLbl}>Who does it apply to?</label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          <button onClick={function () { setAllKids(!allKids); }} style={{ ...kidChip, border: allKids ? "2px solid " + ac : "2px solid #e5e7eb", backgroundColor: allKids ? ac + "20" : "#fff", color: allKids ? "#1a1a2e" : "#666" }}>{allKids ? "✓ All kids" : "All kids"}</button>
          {!allKids && kids.map(function (k) {
            var on = selKids.indexOf(k.id) >= 0;
            return <button key={k.id} onClick={function () { togKid(k.id); }} style={{ ...kidChip, border: on ? "2px solid " + k.color : "2px solid #e5e7eb", backgroundColor: on ? k.color + "20" : "#fff", color: on ? "#1a1a2e" : "#666" }}>{on ? "✓ " : ""}{k.emoji} {k.name}</button>;
          })}
        </div>
      </div>}

      <button onClick={add} disabled={!canAdd} style={{ ...S.nBtn, backgroundColor: ac, opacity: canAdd ? 1 : 0.4, cursor: canAdd ? "pointer" : "default" }}>{btnText}</button>
      {added && <div style={{ textAlign: "center", fontSize: 13, color: "#10B981", fontWeight: 700, marginTop: 8 }}>Added ✓</div>}
    </div>
  );
}

function HBtn({ emoji, label, sub, color, onClick, big }) {
  const [p, setP] = useState(false);
  return (<button onClick={onClick} onPointerDown={function () { setP(true); }} onPointerUp={function () { setP(false); }} onPointerLeave={function () { setP(false); }}
    style={{ ...S.homeBtn, gridColumn: big ? "1 / -1" : undefined, background: "linear-gradient(135deg, " + color + "15, " + color + "08)", border: "2px solid " + color + "30", transform: p ? "scale(.97)" : "scale(1)", boxShadow: p ? "none" : "0 4px 16px " + color + "15" }}>
    <div style={{ fontSize: big ? 48 : 36, marginBottom: 8 }}>{emoji}</div>
    <div style={{ fontSize: big ? 22 : 18, fontWeight: 700, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{label}</div>
    <div style={{ fontSize: 13, color: "#888", fontFamily: "'Nunito', sans-serif" }}>{sub}</div>
  </button>);
}

/* ── HOME ── */
function Home({ kids, ts, settings, isSpec, go }) {
  var cc = kids.filter(function (k) { return ts[k.id]; }).length;
  return (<div style={{ ...S.homeCtr, padding: "24px 24px 24px", position: "relative" }}>
    <div style={{ ...S.homeHdr, marginBottom: 24 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <BFLogo size={56} />
      <div style={{ fontSize: 38, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>BentoFam</div>
    </div>
    <div style={{ fontSize: 16, color: "#666", marginTop: 4, fontFamily: "'Nunito', sans-serif" }}>{orderDateLabel()}</div>
    {isSpec && <div style={{ marginTop: 6, padding: "4px 12px", backgroundColor: "#FFFBEB", borderRadius: 10, fontSize: 13, color: "#92400E", display: "inline-block" }}>✨ Special day!</div>}
    {!settings.dayEnabled && <div style={{ marginTop: 4, padding: "4px 12px", backgroundColor: "#FEF3C7", borderRadius: 10, fontSize: 13, color: "#92400E", display: "inline-block" }}>⏸️ Orders not enabled yet</div>}
    <div style={{ marginTop: 8, fontSize: 14, color: "#999" }}>{cc}/{kids.length} menus completed</div>
    <div style={{ display: "flex", gap: 8, marginTop: 6, justifyContent: "center" }}>
      {kids.map(function (k) { return <Avatar key={k.id} kid={k} size={36} showCheck={true} checked={!!ts[k.id]} />; })}
    </div>
  </div>
  <div style={S.homeGrid}>
    <HBtn emoji="📝" label="Place an Order" sub="Kids tap here!" color="#A78BFA" onClick={function () { go("kiosk"); }} big={true} />
    <HBtn emoji="🛒" label="Inventory" sub="Update availability" color="#FF6B6B" onClick={function () { go("inv"); }} />
    <HBtn emoji="📋" label="Dashboard" sub="Today's orders" color="#FF6B6B" onClick={function () { go("dash"); }} />
    <HBtn emoji="📊" label="History" sub="Past orders" color="#FF6B6B" onClick={function () { go("history"); }} />
    <HBtn emoji="⚙️" label="Settings" sub="Rules & config" color="#FF6B6B" onClick={function () { go("set"); }} />
  </div></div>);
}

/* ── KIOSK ── */
function Kiosk({ kids, menu, rules, hist, ts, calendar, onSubmit, dayOn, isSpec, specInfo, onNudge, onBack, snd }) {
  const [step, setStep] = useState("pick");
  const [kid, setKid] = useState(null);
  const [sel, setSel] = useState({ breakfast: [], lunch: [], snacks: [], afterSchool: [] });
  const [nudged, setNudged] = useState({});
  const [toast, setToast] = useState(null);
  const [pbAlert, setPbAlert] = useState(null);
  const [lpShown, setLpShown] = useState(false);
  const [asShown, setAsShown] = useState(false);
  const [specShown, setSpecShown] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [dismissedSig, setDismissedSig] = useState("");
  const [snackPrompt, setSnackPrompt] = useState(null);
  var em = useMemo(function () { return effMenu(menu, isSpec); }, [menu, isSpec]);
  var kh = kid ? (hist[kid.id] || []) : [];
  var lp = kid ? lunchProvidedFor(calendar, kid.id) : null;
  var asn = kid ? afterSchoolFor(calendar, kid.id) : null;
  var EMPTY_SEL = { breakfast: [], lunch: [], snacks: [], afterSchool: [] };

  function pick(k) {
    if (!dayOn) return;
    setKid(k);
    setLpShown(false);
    setAsShown(false);
    setSpecShown(false);
    setDismissedSig("");
    setSnackPrompt(null);
    var prev = ts[k.id];
    setSel(prev ? { breakfast: prev.breakfast || [], lunch: prev.lunch || [], snacks: prev.snacks || [], afterSchool: prev.afterSchool || [] } : EMPTY_SEL);
    setStep("breakfast");
    if (snd) playTap();
  }
  function maxFor(mt) {
    return mt === "afterSchool" ? AFTER_SCHOOL_COUNT : mt === "snacks" ? rules.snackCount : mt === "breakfast" ? rules.breakfastCount : rules.lunchCount;
  }
  // Signature of a step's current picks; "Change" on the confirm popup remembers it so
  // the popup doesn't reappear until the picks actually change
  function stepSig(st) { return st + ":" + (sel[st] || []).slice().sort().join("|"); }
  useEffect(function () {
    var picking = ["breakfast", "lunch", "snacks", "afterSchool"].indexOf(step) >= 0;
    if (picking && (sel[step] || []).length === maxFor(step) && stepSig(step) !== dismissedSig) setConfirmOpen(true);
    else setConfirmOpen(false);
  }, [sel, step]);
  function tog(mt, name) {
    // PB check for anything picked from the Snacks inventory
    if (mt === "snacks" || mt === "afterSchool") {
      var allItems = [];
      Object.keys(em.Snacks || {}).forEach(function (cat) { (em.Snacks[cat] || []).forEach(function (i) { allItems.push(i); }); });
      var item = allItems.find(function (i) { return i.name === name; });
      if (item && item.peanutButter && sel[mt].indexOf(name) < 0) {
        setPbAlert(name);
        // Still add it, but show the warning
        if (snd) playTap();
        setSel(function (p) {
          var a = p[mt], mx = maxFor(mt);
          if (a.length >= mx) return p;
          return Object.assign({}, p, { [mt]: a.concat([name]) });
        });
        return;
      }
    }
    if (snd) playTap();
    setSel(function (p) {
      var a = p[mt], mx = maxFor(mt);
      if (a.indexOf(name) >= 0) return Object.assign({}, p, { [mt]: a.filter(function (i) { return i !== name; }) });
      if (a.length >= mx) return p;
      return Object.assign({}, p, { [mt]: a.concat([name]) });
    });
  }
  // The after-school step only exists on days this kid has an activity
  var steps = ["pick", "breakfast", "lunch", "snacks"].concat(asn ? ["afterSchool"] : []).concat(["review", "done"]);
  var progSteps = steps.slice(1, steps.length - 1);
  function nxt() {
    var nextStep = steps[steps.indexOf(step) + 1];
    // Show lunch provided popup when entering lunch step
    if (nextStep === "lunch" && lp && !lpShown) {
      setLpShown(true);
    }
    // Same for the after-school popup
    if (nextStep === "afterSchool" && asn && !asShown) {
      setAsShown(true);
    }
    setStep(nextStep);
  }
  function prv() { var i = steps.indexOf(step); if (i > 1) setStep(steps[i - 1]); else { setStep("pick"); setKid(null); } }
  function fvCountOf() {
    var fvs = (em.Snacks["Fruits & Veggies"] || []).map(function (i) { return i.name; });
    return sel.snacks.filter(function (s) { return fvs.indexOf(s) >= 0; }).length;
  }
  function canGo() {
    if (step === "breakfast") return sel.breakfast.length === rules.breakfastCount;
    if (step === "lunch") {
      if (lp) return true; // lunch provided = can skip with 0 or pick if they want
      return sel.lunch.length === rules.lunchCount;
    }
    if (step === "snacks") {
      // 1..snackCount; the fruit/veggie minimum and "are you done?" are asked at Next
      if (sel.snacks.length < 1 || sel.snacks.length > rules.snackCount) return false;
      var sws = (em.Snacks["Sweet"] || []).map(function (i) { return i.name; });
      var swCount = sel.snacks.filter(function (s) { return sws.indexOf(s) >= 0; }).length;
      if (rules.maxSweet > 0 && swCount > rules.maxSweet) return false;
      return true;
    }
    if (step === "afterSchool") return sel.afterSchool.length === AFTER_SCHOOL_COUNT;
    return true;
  }
  // Next with the snack-step prompts: fruit/veggie minimum first (waived when lunch
  // is provided), then "are you done?" when fewer than the max are picked
  function goNext() {
    setConfirmOpen(false);
    if (step !== "snacks") { nxt(); return; }
    var n = sel.snacks.length, max = rules.snackCount;
    if (!lp && fvCountOf() < rules.minFruitVeggie) { setSnackPrompt({ kind: "fv", min: rules.minFruitVeggie }); return; }
    if (n < max) { setSnackPrompt({ kind: "done", n: n, left: max - n, items: sel.snacks.slice() }); return; }
    nxt();
  }
  function flash(msg) { setToast(msg); setTimeout(function () { setToast(null); }, 3000); }
  async function submit() {
    try { await onSubmit(kid.id, sel); setStep("done"); }
    catch (e) { flash("😕 Couldn't save the order. Check Wi-Fi and tap Submit again."); }
  }
  function done() { setStep("pick"); setKid(null); setSel(EMPTY_SEL); }
  async function nudge(id) {
    if (snd) playTap();
    var ok = await onNudge(id);
    if (ok) {
      setNudged(function (p) { return Object.assign({}, p, { [id]: true }); });
      flash("📢 Mom & Dad have been nudged!");
    } else {
      flash("😕 Couldn't reach Mom & Dad's phones. Try again in a minute.");
    }
  }

  var hc = kid ? kid.color : "#FF6B6B";
  var snackLabel = lp ? "Pick at least 1 snack 🍎" : "Pick " + rules.snackCount + " snacks 🍎";
  var lunchLabel = lp ? "Lunch provided! 🎉 Pick one if you want" : "Pick lunch 🥪";
  var sLbl = { breakfast: "Pick breakfast 🍳", lunch: lunchLabel, snacks: snackLabel, afterSchool: "🎒 After-School Snack", review: "Review your picks ✨" };

  function renderPicker(mt) {
    var section = em[mt];
    var cats = sortCategories(Object.keys(section), section, kh, rules.sortOrder);
    return (<div style={{ padding: "12px 16px 4px" }}>{cats.map(function (cat, ci) {
      var items = sortItems(section[cat], kh, rules.sortOrder);
      if (!items.length) return null;
      var blk = mealRules(sel[step], mt, rules, kh).blocked;
      var mx = mt === "Breakfast" ? rules.breakfastCount : rules.lunchCount;
      return (<div key={cat} style={{ marginBottom: ci === cats.length - 1 ? 4 : 16 }}>
        <div style={S.cLbl}>{cat}</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {items.map(function (i) {
            var isSel = sel[step].indexOf(i.name) >= 0, isBlk = blk.has(i.name) && !isSel, isDis = isBlk || (sel[step].length >= mx && !isSel);
            return <Chip key={i.name} label={i.name} sel={isSel} dis={isDis} blk={isBlk} spec={i.special} isNew={isNewItem(i)} hasPB={i.peanutButter} onClick={function () { if (!isDis) tog(step, i.name); }} />;
          })}
        </div>
      </div>);
    })}</div>);
  }

  function renderSnacks() {
    var res = snackRules(sel.snacks, em, rules, kh);
    var fvs = (em.Snacks["Fruits & Veggies"] || []).map(function (i) { return i.name; });
    var fvC = sel.snacks.filter(function (s) { return fvs.indexOf(s) >= 0; }).length;
    var sws = (em.Snacks["Sweet"] || []).map(function (i) { return i.name; });
    var swC = sel.snacks.filter(function (s) { return sws.indexOf(s) >= 0; }).length;
    var ic = { "Fruits & Veggies": "🥗", Salty: "🧂", Savory: "🧀", Sweet: "🍬" };
    var snackCats = sortCategories(Object.keys(em.Snacks), em.Snacks, kh, rules.sortOrder);
    return (<div style={{ padding: "12px 16px 4px" }}>
      <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        {!lp && <RuleChip label={fvC + "/" + rules.minFruitVeggie + " fruit/veggie"} met={fvC >= rules.minFruitVeggie} icon="🥕" />}
        <RuleChip label={swC + "/" + rules.maxSweet + " sweet max"} met={swC < rules.maxSweet} warn={swC >= rules.maxSweet} icon="🍬" />
        <RuleChip label={sel.snacks.length + "/" + (lp ? "1+" : rules.snackCount) + " picked"} met={lp ? sel.snacks.length >= 1 : sel.snacks.length === rules.snackCount} icon="✋" />
      </div>
      {res.warn.map(function (w, i) { return <div key={i} style={{ padding: "8px 12px", backgroundColor: "#FEF3C7", borderRadius: 10, marginBottom: 8, fontSize: 14, color: "#92400E" }}>⚠️ {w}</div>; })}
      {snackCats.map(function (cat, ci) {
        var items = sortItems(em.Snacks[cat], kh, rules.sortOrder); if (!items.length) return null;
        return (<div key={cat} style={{ marginBottom: ci === snackCats.length - 1 ? 4 : 16 }}>
          <div style={S.cLbl}>{ic[cat] || ""} {cat}</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {items.map(function (i) {
              var isSel = sel.snacks.indexOf(i.name) >= 0, isBlk = res.blocked.has(i.name) && !isSel, isDis = isBlk || (sel.snacks.length >= rules.snackCount && !isSel);
              return <Chip key={i.name} label={i.name} sel={isSel} dis={isDis} blk={isBlk} spec={i.special} isNew={isNewItem(i)} hasPB={i.peanutButter} onClick={function () { if (!isDis) tog("snacks", i.name); }} />;
            })}
          </div>
        </div>);
      })}
    </div>);
  }

  // Extra snack from the same Snacks inventory; no rule chips or blocking, just the max count and the PB alert
  function renderAfterSchool() {
    var ic = { "Fruits & Veggies": "🥗", Salty: "🧂", Savory: "🧀", Sweet: "🍬" };
    var snackCats = sortCategories(Object.keys(em.Snacks), em.Snacks, kh, rules.sortOrder);
    return (<div style={{ padding: "12px 16px 4px" }}>
      <div style={{ fontSize: 13, color: "#888", marginBottom: 12, fontFamily: "'Nunito', sans-serif" }}>For {asn && asn.label ? asn.label : "your activity"} · packed separately</div>
      {snackCats.map(function (cat, ci) {
        var items = sortItems(em.Snacks[cat], kh, rules.sortOrder); if (!items.length) return null;
        return (<div key={cat} style={{ marginBottom: ci === snackCats.length - 1 ? 4 : 16 }}>
          <div style={S.cLbl}>{ic[cat] || ""} {cat}</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {items.map(function (i) {
              var isSel = sel.afterSchool.indexOf(i.name) >= 0, isDis = sel.afterSchool.length >= AFTER_SCHOOL_COUNT && !isSel;
              return <Chip key={i.name} label={i.name} sel={isSel} dis={isDis} spec={i.special} isNew={isNewItem(i)} hasPB={i.peanutButter} onClick={function () { if (!isDis) tog("afterSchool", i.name); }} />;
            })}
          </div>
        </div>);
      })}
    </div>);
  }

  var reviewSecs = [{ l: "🍳 Breakfast", items: sel.breakfast }, { l: "🥪 Lunch", items: sel.lunch }, { l: "🍎 Snacks", items: sel.snacks }];
  if (asn) reviewSecs.push({ l: "🎒 After School", items: sel.afterSchool });

  // Kiosk modals share one overlay/card look; only one shows at a time and the
  // step-confirm popup yields to every other one
  var overlay = { position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 20 };
  var card = { backgroundColor: "#fff", borderRadius: 20, padding: "28px 24px", maxWidth: 380, textAlign: "center", boxShadow: "0 12px 40px rgba(0,0,0,0.3)" };
  var stepMeta = { breakfast: ["🍳", "Breakfast"], lunch: ["🥪", "Lunch"], snacks: ["🍎", "Snacks"], afterSchool: ["🎒", "After-School Snack"] };
  var lpModal = step === "lunch" && lp && lpShown && sel.lunch.length === 0;
  var asModal = step === "afterSchool" && asn && asShown && sel.afterSchool.length === 0;
  var specModal = !!(kid && step !== "pick" && step !== "done" && specInfo && !specShown);
  var otherModal = !!pbAlert || !!lpModal || !!asModal || !!snackPrompt || specModal;

  return (<div style={S.kCtr}>
    {toast && <div style={{ position: "fixed", top: 80, left: "50%", transform: "translateX(-50%)", padding: "14px 28px", backgroundColor: "#1a1a2e", color: "#fff", borderRadius: 16, fontSize: 16, fontWeight: 700, fontFamily: "'Fredoka', sans-serif", zIndex: 9999, boxShadow: "0 8px 32px rgba(0,0,0,0.2)", animation: "toastIn .3s ease-out" }}>{toast}</div>}
    {pbAlert && <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 20 }}>
      <div style={{ backgroundColor: "#fff", borderRadius: 20, padding: "28px 24px", maxWidth: 380, textAlign: "center", boxShadow: "0 12px 40px rgba(0,0,0,0.3)" }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🥜</div>
        <div style={{ fontSize: 16, color: "#374151", lineHeight: 1.5, marginBottom: 20, fontFamily: "'Nunito', sans-serif" }}>
          You picked <span style={{ fontStyle: "italic", fontWeight: 700 }}>{pbAlert}</span> which contains peanut butter. Remember, you can't eat this during snack time in your classroom — only during lunch time in the cafeteria.
        </div>
        <button onClick={function () { setPbAlert(null); }} style={{ padding: "12px 32px", borderRadius: 14, border: "none", backgroundColor: "#F59E0B", color: "#fff", fontSize: 16, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Yes, I understand</button>
      </div>
    </div>}
    {step === "lunch" && lp && lpShown && sel.lunch.length === 0 && <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 20 }}>
      <div style={{ backgroundColor: "#fff", borderRadius: 20, padding: "28px 24px", maxWidth: 380, textAlign: "center", boxShadow: "0 12px 40px rgba(0,0,0,0.3)" }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🎉</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif", marginBottom: 8 }}>{kid ? kid.name : ""}, you get a free lunch today!</div>
        <div style={{ fontSize: 15, color: "#666", marginBottom: 20, fontFamily: "'Nunito', sans-serif" }}>{lp.label || "Lunch provided"}</div>
        <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
          <button onClick={function () { setLpShown(false); nxt(); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#10B981", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Skip lunch, pick snacks →</button>
          <button onClick={function () { setLpShown(false); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#f3f4f6", color: "#666", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>I still want to pick</button>
        </div>
      </div>
    </div>}
    {step === "afterSchool" && asn && asShown && sel.afterSchool.length === 0 && <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 20 }}>
      <div style={{ backgroundColor: "#fff", borderRadius: 20, padding: "28px 24px", maxWidth: 380, textAlign: "center", boxShadow: "0 12px 40px rgba(0,0,0,0.3)" }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🎒</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif", marginBottom: 8 }}>{kid ? kid.name : ""}, you have {asn.label || "an activity"} today!</div>
        <div style={{ fontSize: 15, color: "#666", marginBottom: 20, fontFamily: "'Nunito', sans-serif" }}>Pick 1 snack to pack separately for after school.</div>
        <button onClick={function () { setAsShown(false); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#3B82F6", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Got it, pick a snack →</button>
      </div>
    </div>}
    {specModal && <div style={overlay}>
      <div style={card}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>⭐</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif", marginBottom: 8 }}>It's a special day!</div>
        <div style={{ fontSize: 15, color: "#666", marginBottom: 20, fontFamily: "'Nunito', sans-serif" }}>{specInfo && specInfo.label ? specInfo.label + " · special ⭐ items are unlocked today!" : "Mom & Dad made today a special day · special ⭐ items are unlocked!"}</div>
        <button onClick={function () { setSpecShown(true); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#F59E0B", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Let's go →</button>
      </div>
    </div>}
    {snackPrompt && snackPrompt.kind === "fv" && <div style={overlay}>
      <div style={card}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🍎</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif", marginBottom: 8 }}>Hold on!</div>
        <div style={{ fontSize: 15, color: "#666", marginBottom: 20, fontFamily: "'Nunito', sans-serif" }}>{snackPrompt.min === 1 ? "At least 1 of your snacks must be a fruit or veggie. Pick one!" : "At least " + snackPrompt.min + " of your snacks must be fruits or veggies. Pick some!"}</div>
        <button onClick={function () { setSnackPrompt(null); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#10B981", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>{snackPrompt.min === 1 ? "OK, pick one" : "OK, pick some"}</button>
      </div>
    </div>}
    {snackPrompt && snackPrompt.kind === "done" && <div style={overlay}>
      <div style={card}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🤔</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif", marginBottom: 8 }}>Are you done?</div>
        <div style={{ fontSize: 15, color: "#666", marginBottom: 20, fontFamily: "'Nunito', sans-serif" }}>You picked {snackPrompt.n} snack{snackPrompt.n === 1 ? "" : "s"}: {snackPrompt.items.join(", ")}. You can choose up to {snackPrompt.left} more.</div>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={function () { setSnackPrompt(null); nxt(); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#10B981", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Yes, I'm done →</button>
          <button onClick={function () { setSnackPrompt(null); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#f3f4f6", color: "#666", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Pick more</button>
        </div>
      </div>
    </div>}
    {confirmOpen && !otherModal && stepMeta[step] && <div style={overlay}>
      <div style={card}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>{stepMeta[step][0]}</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif", marginBottom: 12 }}>{stepMeta[step][1]}</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginBottom: 20 }}>
          {(sel[step] || []).map(function (item) {
            return <span key={item} style={{ padding: "10px 16px", borderRadius: 16, border: "2.5px solid " + hc, backgroundColor: hc + "20", color: "#1a1a2e", fontSize: 16, fontWeight: 700, fontFamily: "'Nunito', sans-serif" }}>{item}</span>;
          })}
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
          <button onClick={goNext} style={{ padding: "12px 28px", borderRadius: 14, border: "none", backgroundColor: hc, color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Next →</button>
          <button onClick={function () { setDismissedSig(stepSig(step)); setConfirmOpen(false); }} style={{ padding: "12px 24px", borderRadius: 14, border: "none", backgroundColor: "#f3f4f6", color: "#666", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>Change</button>
        </div>
      </div>
    </div>}
    <style>{"@keyframes toastIn{from{opacity:0;transform:translateX(-50%) translateY(-20px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}"}</style>
    <div style={{ ...S.kHdr, background: "linear-gradient(135deg, " + hc + ", " + hc + "CC)" }}>
      <button onClick={step === "pick" ? onBack : prv} style={S.kBack}>← {step === "pick" ? "Home" : "Back"}</button>
      <div style={{ textAlign: "center", flex: 1 }}>
        {step === "pick" && <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "'Fredoka', sans-serif" }}>Who's ordering?</div>}
        {step === "done" && <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "'Fredoka', sans-serif" }}>All done!</div>}
        {step !== "pick" && step !== "done" && kid && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
          <Avatar kid={kid} size={32} />
          <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "'Fredoka', sans-serif" }}>{kid.name}</div>
        </div>}
        {step !== "pick" && step !== "done" && <div style={{ fontSize: 13, opacity: .9, marginTop: 2 }}>{sLbl[step]}</div>}
      </div>
      <div style={{ width: 70 }} />
    </div>
    {kid && step !== "done" && <div style={S.prog}>{progSteps.map(function (s, i) {
      return (<div key={s} style={{ flex: 1, display: "flex", alignItems: "center" }}>
        <div style={{ height: 6, flex: 1, borderRadius: 3, backgroundColor: progSteps.indexOf(step) >= i ? hc : "#e5e7eb", transition: "background-color .3s" }} />
        {i < progSteps.length - 1 && <div style={{ width: 4 }} />}
      </div>);
    })}</div>}

    <div style={S.kBody}>
      {step === "pick" && <div style={{ display: "flex", flexDirection: "column", gap: 16, padding: "20px 16px" }}>
        {!dayOn && <div style={{ padding: "16px 20px", borderRadius: 16, backgroundColor: "#FEF3C7", textAlign: "center" }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>⏸️</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#92400E", fontFamily: "'Fredoka', sans-serif" }}>Menu not ready yet!</div>
          <div style={{ fontSize: 14, color: "#A16207", marginTop: 4 }}>Ask mom or dad to enable today's orders</div>
        </div>}
        {kids.map(function (k) {
          var has = !!ts[k.id], can = dayOn;
          return (<div key={k.id} onClick={function () { if (can) pick(k); }}
            style={{ display: "flex", alignItems: "center", gap: 16, padding: "20px 24px", borderRadius: 20, border: "none", backgroundColor: has ? "#f0fdf4" : "#fff", boxShadow: can ? "0 4px 20px rgba(0,0,0,.08)" : "none", cursor: can ? "pointer" : "default", opacity: !dayOn ? .8 : 1, transition: "all .2s", textAlign: "left" }}>
            <Avatar kid={k} size={64} showCheck={true} checked={has} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 700, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{k.name}</div>
              {has && <div style={{ fontSize: 14, color: "#10B981", fontWeight: 600, marginTop: 2 }}>✓ Done at {fTime(ts[k.id].completedAt)} · tap to edit</div>}
              {!dayOn && !has && !nudged[k.id] && <button onClick={function (e) { e.stopPropagation(); nudge(k.id); }} style={{ marginTop: 6, padding: "8px 18px", borderRadius: 12, border: "none", backgroundColor: "#F59E0B", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "'Fredoka', sans-serif" }}>📢 Nudge Mom & Dad</button>}
              {!dayOn && nudged[k.id] && <div style={{ fontSize: 14, color: "#F59E0B", fontWeight: 700, marginTop: 6, fontFamily: "'Fredoka', sans-serif" }}>📢 Nudged! They're on it.</div>}
            </div>
            {can && <div style={{ fontSize: 24, color: k.color }}>→</div>}
          </div>);
        })}
      </div>}

      {step === "breakfast" && renderPicker("Breakfast")}
      {step === "lunch" && renderPicker("Lunch")}
      {step === "snacks" && renderSnacks()}
      {step === "afterSchool" && renderAfterSchool()}

      {step === "review" && <div style={{ padding: "16px 16px 8px" }}>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <Avatar kid={kid} size={56} />
          <div style={{ fontSize: 22, fontWeight: 700, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e", marginTop: 8 }}>{kid.name}'s Menu</div>
          {ts[kid.id] && <div style={{ fontSize: 14, color: "#F59E0B", fontWeight: 600, marginTop: 4 }}>📝 Updating previous order</div>}
        </div>
        {reviewSecs.map(function (sec) {
          return (<div key={sec.l} style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#888", marginBottom: 6, fontFamily: "'Fredoka', sans-serif" }}>{sec.l}</div>
            {sec.items.map(function (item) { return <div key={item} style={{ padding: "10px 14px", backgroundColor: "#f9fafb", borderRadius: 12, marginBottom: 5, fontSize: 17, fontWeight: 600, color: "#1a1a2e", fontFamily: "'Nunito', sans-serif" }}>{item}</div>; })}
          </div>);
        })}
      </div>}

      {step === "done" && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40, textAlign: "center", minHeight: 400 }}>
        <div style={{ fontSize: 80, marginBottom: 16, animation: "bounce .6s infinite alternate" }}>🎉</div>
        <div style={{ fontSize: 28, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>Awesome, {kid ? kid.name : ""}!</div>
        <div style={{ fontSize: 16, color: "#666", marginTop: 8 }}>{ts[kid ? kid.id : ""] && ts[kid ? kid.id : ""].updated ? "Menu updated!" : "Menu locked in!"}</div>
        <div style={{ display: "flex", gap: 12, marginTop: 32 }}>
          <button onClick={done} style={{ ...S.nBtn, backgroundColor: "#4ECDC4", padding: "14px 28px", width: "auto" }}>Next kid →</button>
          <button onClick={onBack} style={{ ...S.nBtn, backgroundColor: "#e5e7eb", color: "#374151", padding: "14px 28px", width: "auto" }}>Home</button>
        </div>
        <style>{"@keyframes bounce{from{transform:translateY(0)}to{transform:translateY(-12px)}}"}</style>
      </div>}
    </div>

    {kid && step !== "pick" && step !== "done" && <div style={{ padding: "12px 16px", borderTop: "1px solid #e5e7eb", backgroundColor: "#fff" }}>
      {step !== "review"
        ? <button onClick={goNext} disabled={!canGo()} style={{ ...S.nBtn, backgroundColor: canGo() ? hc : "#d1d5db", cursor: canGo() ? "pointer" : "not-allowed" }}>{steps[steps.indexOf(step) + 1] === "review" ? "Review →" : "Next →"}</button>
        : <button onClick={submit} style={{ ...S.nBtn, backgroundColor: "#10B981" }}>{ts[kid.id] ? "📝 Update menu!" : "✅ Submit!"}</button>}
    </div>}
  </div>);
}

/* ── INVENTORY ── */
function InvItem({ item, sub, onTog, onStar, onTogPB, onTogUtensil, onDel, onRename, onFlagNew, expanded, onExpand, cfm, onCfm, onCancel }) {
  const [editName, setEditName] = useState(item.name);
  const [showNewPicker, setShowNewPicker] = useState(false);
  const [confirmDel, setConfirmDel] = useState(false);
  var itemIsNew = isNewItem(item);

  // Reset local state when panel closes
  useEffect(function () {
    if (!expanded) { setShowNewPicker(false); setConfirmDel(false); setEditName(item.name); }
  }, [expanded, item.name]);

  // Delete confirmation (works in both edit and non-edit mode for the expand panel)
  if (cfm) return (<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", marginBottom: 4, borderRadius: 12, backgroundColor: "#FEF2F2" }}>
    <span style={{ fontSize: 14, fontWeight: 600, color: "#991B1B" }}>Remove "{item.name}"?</span>
    <div style={{ display: "flex", gap: 6 }}>
      <button onClick={onCfm} style={{ ...S.mini, backgroundColor: "#DC2626", color: "#fff" }}>Yes</button>
      <button onClick={onCancel} style={{ ...S.mini, backgroundColor: "#f3f4f6", color: "#666" }}>No</button>
    </div>
  </div>);

  return (<div style={{ marginBottom: 4, borderRadius: 12, backgroundColor: expanded ? "#F8FAFC" : item.available ? "#F0FDF4" : "#fff", border: expanded ? "2px solid #e2e8f0" : "2px solid transparent" }}>
    <div style={{ display: "flex", alignItems: "center", padding: "12px 14px" }}>
      <button onClick={onTog} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between", background: "none", border: "none", cursor: "pointer", padding: 0 }}>
        <div style={{ textAlign: "left" }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: item.available ? "#166534" : "#9ca3af" }}>
            {item.special && <span style={{ color: "#F59E0B" }}>⭐ </span>}
            {itemIsNew && <span style={{ color: "#3B82F6" }}>🆕 </span>}
            {item.peanutButter && <span style={{ color: "#92400E" }}>🥜 </span>}
            {item.utensil === "fork" && <span>🍴 </span>}
            {item.utensil === "spoon" && <span>🥄 </span>}
            {item.utensil === "both" && <span>🍴🥄 </span>}
            {item.name}
          </div>
          {sub && <div style={{ fontSize: 12, color: "#bbb" }}>{sub}</div>}
        </div>
        <div style={{ width: 44, height: 26, borderRadius: 13, backgroundColor: item.available ? "#10B981" : "#d1d5db", position: "relative" }}>
          <div style={{ position: "absolute", top: 3, left: item.available ? 21 : 3, width: 20, height: 20, borderRadius: "50%", backgroundColor: "#fff", transition: "left .2s", boxShadow: "0 1px 3px rgba(0,0,0,.2)" }} />
        </div>
      </button>
      <button onClick={function () { onExpand(expanded ? null : item.name); }} style={{ marginLeft: 8, width: 32, height: 32, borderRadius: "50%", border: "none", backgroundColor: expanded ? "#1a1a2e" : "#f3f4f6", color: expanded ? "#fff" : "#888", fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>⋯</button>
    </div>

    {expanded && <div style={{ padding: "0 14px 12px" }}>
      <div style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "center" }}>
        <input type="text" value={editName} onChange={function (e) { setEditName(e.target.value); }}
          onKeyDown={function (e) { if (e.key === "Enter" && editName.trim() && editName.trim() !== item.name) { onRename(editName.trim()); } }}
          style={{ ...S.sInput, flex: 1, padding: "8px 12px", fontSize: 16 }} />
        {editName.trim() && editName.trim() !== item.name && <button onClick={function () { onRename(editName.trim()); }}
          style={{ ...S.mini, backgroundColor: "#10B981", color: "#fff", padding: "6px 14px", fontSize: 13 }}>Rename</button>}
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button onClick={onStar} style={{ padding: "8px 14px", borderRadius: 10, border: "none", backgroundColor: item.special ? "#FFFBEB" : "#f3f4f6", color: item.special ? "#92400E" : "#666", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          {item.special ? "⭐ Special" : "⭐ Set special"}
        </button>
        <button onClick={onTogPB} style={{ padding: "8px 14px", borderRadius: 10, border: "none", backgroundColor: item.peanutButter ? "#FEF3C7" : "#f3f4f6", color: item.peanutButter ? "#92400E" : "#666", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          {item.peanutButter ? "🥜 P.B." : "🥜 Has P.B."}
        </button>
        <button onClick={onTogUtensil} style={{ padding: "8px 14px", borderRadius: 10, border: "none", backgroundColor: item.utensil ? "#EFF6FF" : "#f3f4f6", color: item.utensil ? "#1E40AF" : "#666", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          {item.utensil === "fork" ? "🍴 Fork" : item.utensil === "spoon" ? "🥄 Spoon" : item.utensil === "both" ? "🍴🥄 Both" : "🍴 Utensil"}
        </button>
        <button onClick={function () { setShowNewPicker(!showNewPicker); }} style={{ padding: "8px 14px", borderRadius: 10, border: "none", backgroundColor: itemIsNew ? "#DBEAFE" : "#f3f4f6", color: itemIsNew ? "#1E40AF" : "#666", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          {itemIsNew ? "🆕 Flagged" : "🆕 Flag as new"}
        </button>
        {!confirmDel
          ? <button onClick={function () { setConfirmDel(true); }} style={{ padding: "8px 14px", borderRadius: 10, border: "none", backgroundColor: "#FEE2E2", color: "#991B1B", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>🗑️ Delete</button>
          : <div style={{ display: "flex", gap: 6 }}>
              <button onClick={function () { onDel(); }} style={{ padding: "8px 14px", borderRadius: 10, border: "none", backgroundColor: "#DC2626", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Confirm delete</button>
              <button onClick={function () { setConfirmDel(false); }} style={{ padding: "8px 14px", borderRadius: 10, border: "none", backgroundColor: "#f3f4f6", color: "#666", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Cancel</button>
            </div>
        }
      </div>

      {showNewPicker && <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
        {[1, 2, 3, 5].map(function (d) {
          return <button key={d} onClick={function () { onFlagNew(d); setShowNewPicker(false); }} style={{ padding: "6px 14px", borderRadius: 10, border: "none", backgroundColor: "#DBEAFE", color: "#1E40AF", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>{d} day{d > 1 ? "s" : ""}</button>;
        })}
        {itemIsNew && <button onClick={function () { onFlagNew(0); setShowNewPicker(false); }} style={{ padding: "6px 14px", borderRadius: 10, border: "none", backgroundColor: "#FEE2E2", color: "#991B1B", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Remove</button>}
      </div>}
    </div>}
  </div>);
}

function Inv({ menu, onSave, settings, onTogDay, onTogSpec, isSpec, onResetToday, kids, onBack }) {
  const [tab, setTab] = useState("Breakfast");
  const [search, setSearch] = useState("");
  const [adding, setAdding] = useState(null);
  const [nn, setNn] = useState("");
  const [addCat, setAddCat] = useState(false);
  const [nc, setNc] = useState("");
  const [del, setDel] = useState(null);
  const [restock, setRestock] = useState(false);
  const [confirmReset, setConfirmReset] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);

  function ti(mt, cat, name) { var m = deepClone(menu); m[mt][cat] = m[mt][cat].map(function (i) { return i.name === name ? Object.assign({}, i, { available: !i.available }) : i; }); onSave(m); }
  function tsp(mt, cat, name) { var m = deepClone(menu); m[mt][cat] = m[mt][cat].map(function (i) { return i.name === name ? Object.assign({}, i, { special: !i.special }) : i; }); onSave(m); }
  function tp(mt, cat, name) { var m = deepClone(menu); m[mt][cat] = m[mt][cat].map(function (i) { return i.name === name ? Object.assign({}, i, { peanutButter: !i.peanutButter }) : i; }); onSave(m); }
  function tu(mt, cat, name) {
    var m = deepClone(menu);
    m[mt][cat] = m[mt][cat].map(function (i) {
      if (i.name !== name) return i;
      var cur = i.utensil || "none";
      var next = cur === "none" ? "fork" : cur === "fork" ? "spoon" : cur === "spoon" ? "both" : "none";
      return Object.assign({}, i, { utensil: next === "none" ? undefined : next });
    });
    onSave(m);
  }
  function ma(mt, a) { var m = deepClone(menu); Object.keys(m[mt]).forEach(function (c) { m[mt][c] = m[mt][c].map(function (i) { return Object.assign({}, i, { available: a }); }); }); onSave(m); }
  function ai(cat) { var n = nn.trim(); if (!n) return; if ((menu[tab][cat] || []).some(function (i) { return i.name.toLowerCase() === n.toLowerCase(); })) return; var m = deepClone(menu); m[tab][cat].push({ name: n, available: true }); onSave(m); setNn(""); setAdding(null); }
  function ri(cat, name) { var m = deepClone(menu); m[tab][cat] = m[tab][cat].filter(function (i) { return i.name !== name; }); if (!m[tab][cat].length) delete m[tab][cat]; onSave(m); setDel(null); }
  function rn(mt, cat, oldName, newName) { var m = deepClone(menu); m[mt][cat] = m[mt][cat].map(function (i) { return i.name === oldName ? Object.assign({}, i, { name: newName }) : i; }); onSave(m); }
  function fn(mt, cat, name, days) {
    var m = deepClone(menu);
    m[mt][cat] = m[mt][cat].map(function (i) {
      if (i.name !== name) return i;
      if (days === 0) { var c = Object.assign({}, i); delete c.newUntil; return c; }
      var d = new Date(); d.setDate(d.getDate() + days);
      return Object.assign({}, i, { newUntil: d.toISOString() });
    });
    onSave(m);
  }
  function ac() { var n = nc.trim(); if (!n || menu[tab][n]) return; var m = deepClone(menu); m[tab][n] = []; onSave(m); setNc(""); setAddCat(false); setAdding({ category: n }); }
  function rc(cat) { var m = deepClone(menu); delete m[tab][cat]; onSave(m); setDel(null); }

  var sec = menu[tab];
  var all = []; Object.keys(sec).forEach(function (c) { sec[c].forEach(function (i) { all.push(Object.assign({}, i, { category: c })); }); });
  var filt = search ? all.filter(function (i) { return i.name.toLowerCase().indexOf(search.toLowerCase()) >= 0; }).sort(function (a, b) { return a.name.localeCompare(b.name); }) : null;
  var avC = all.filter(function (i) { return i.available; }).length;

  return (<div style={S.iCtr}>
    <div style={S.sHdr}>
      <button onClick={onBack} style={S.back}>← Home</button>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ fontSize: 24, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>🛒 Inventory</div>
      </div>
      <div style={{ fontSize: 13, color: "#888" }}>{avC}/{all.length} available</div>
    </div>
    <div style={{ padding: "0 16px", marginBottom: 8, display: "flex", flexDirection: "column", gap: 6 }}>
      <button onClick={onTogDay} style={{ width: "100%", padding: "12px 16px", borderRadius: 12, border: "none", cursor: "pointer", backgroundColor: settings.dayEnabled ? "#D1FAE5" : "#FEF3C7", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: settings.dayEnabled ? "#065F46" : "#92400E" }}>{settings.dayEnabled ? "✅ Orders OPEN" : "⏸️ Orders CLOSED"}</span>
        <div style={{ width: 44, height: 26, borderRadius: 13, backgroundColor: settings.dayEnabled ? "#10B981" : "#d1d5db", position: "relative" }}><div style={{ position: "absolute", top: 3, left: settings.dayEnabled ? 21 : 3, width: 20, height: 20, borderRadius: "50%", backgroundColor: "#fff", transition: "left .2s" }} /></div>
      </button>
      <button onClick={onTogSpec} style={{ width: "100%", padding: "10px 16px", borderRadius: 12, border: "none", cursor: "pointer", backgroundColor: isSpec ? "#FFFBEB" : "#f9fafb", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: isSpec ? "#92400E" : "#888" }}>{isSpec ? "✨ Special ON" : "✨ Special OFF"}</span>
        <div style={{ width: 44, height: 26, borderRadius: 13, backgroundColor: isSpec ? "#F59E0B" : "#d1d5db", position: "relative" }}><div style={{ position: "absolute", top: 3, left: isSpec ? 21 : 3, width: 20, height: 20, borderRadius: "50%", backgroundColor: "#fff", transition: "left .2s" }} /></div>
      </button>
    </div>
    <div style={S.tRow}>{["Breakfast", "Lunch", "Snacks"].map(function (t) {
      return <button key={t} onClick={function () { setTab(t); setSearch(""); setAdding(null); setAddCat(false); setDel(null); setExpandedItem(null); }} style={{ ...S.tab, backgroundColor: tab === t ? "#1a1a2e" : "transparent", color: tab === t ? "#fff" : "#666" }}>{t === "Breakfast" ? "🍳" : t === "Lunch" ? "🥪" : "🍎"} {t}</button>;
    })}</div>
    <div style={{ padding: "0 16px", marginBottom: 12 }}><input type="text" placeholder="Search..." value={search} onChange={function (e) { setSearch(e.target.value); }} style={S.sIn} /></div>
    <div style={{ display: "flex", gap: 8, padding: "0 16px", marginBottom: 8 }}>
      <button onClick={function () { ma(tab, true); }} style={S.bBtn}>✅ All available</button>
      <button onClick={function () { ma(tab, false); }} style={{ ...S.bBtn, backgroundColor: "#FEE2E2", color: "#991B1B" }}>❌ All unavailable</button>
    </div>
    <div style={{ display: "flex", gap: 8, padding: "0 16px", marginBottom: 8 }}>
      <button onClick={function () { setRestock(!restock); }} style={{ ...S.bBtn, backgroundColor: restock ? "#DBEAFE" : "#f3f4f6", color: restock ? "#1E40AF" : "#666" }}>{restock ? "📦 Restock mode ON" : "📦 Restock mode"}</button>
      {!confirmReset && <button onClick={function () { setConfirmReset(true); }} style={{ ...S.bBtn, backgroundColor: "#FEF3C7", color: "#92400E" }}>🔄 Reset orders</button>}
      {confirmReset && <button onClick={function () { onResetToday(); setConfirmReset(false); }} style={{ ...S.bBtn, backgroundColor: "#DC2626", color: "#fff" }}>Confirm reset?</button>}
      {confirmReset && <button onClick={function () { setConfirmReset(false); }} style={{ ...S.bBtn, backgroundColor: "#f3f4f6", color: "#666" }}>Cancel</button>}
    </div>
    {confirmReset && <div style={{ padding: "0 16px", marginBottom: 8 }}>
      <div style={{ padding: "8px 12px", backgroundColor: "#FEF2F2", borderRadius: 10, fontSize: 13, color: "#991B1B" }}>⚠️ This will clear all {kids.length} kids' orders for today.</div>
    </div>}
    <div style={{ padding: "0 16px", overflowY: "auto", flex: 1, paddingBottom: 80 }}>
      {filt ? filt.map(function (i) { return <InvItem key={i.name + i.category} item={i} sub={i.category} onTog={function () { ti(tab, i.category, i.name); }} onStar={function () { tsp(tab, i.category, i.name); }} onTogPB={function () { tp(tab, i.category, i.name); }} onTogUtensil={function () { tu(tab, i.category, i.name); }} onDel={function () { ri(i.category, i.name); }} onRename={function (n) { rn(tab, i.category, i.name, n); }} onFlagNew={function (d) { fn(tab, i.category, i.name, d); }} expanded={expandedItem === i.name + ":" + i.category} onExpand={function (v) { setExpandedItem(v ? i.name + ":" + i.category : null); }} />; }) : <>
        {Object.keys(sec).sort().map(function (cat) {
          var items = restock ? sec[cat].filter(function (i) { return !i.available; }) : sec[cat];
          items = items.slice().sort(function (a, b) { return a.name.localeCompare(b.name); });
          if (restock && !items.length) return null;
          return (<div key={cat} style={{ marginBottom: 20 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
              <div style={S.cLbl}>{cat}</div>
              <div style={{ display: "flex", gap: 6 }}>
                <button onClick={function () { setAdding({ category: cat }); setNn(""); }} style={{ ...S.mini, backgroundColor: "#D1FAE5", color: "#065F46" }}>+ Item</button>
                {!items.length && <button onClick={function () { setDel("cat:" + cat); }} style={{ ...S.mini, backgroundColor: "#FEE2E2", color: "#991B1B" }}>Remove</button>}
              </div>
            </div>
            {adding && adding.category === cat && <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
              <input type="text" placeholder="New item..." value={nn} onChange={function (e) { setNn(e.target.value); }} onKeyDown={function (e) { if (e.key === "Enter") ai(cat); }} autoFocus style={{ ...S.sInput, flex: 1 }} />
              <button onClick={function () { ai(cat); }} style={{ ...S.mini, backgroundColor: "#10B981", color: "#fff", padding: "8px 16px" }}>Add</button>
              <button onClick={function () { setAdding(null); }} style={{ ...S.mini, backgroundColor: "#f3f4f6", color: "#666", padding: "8px 12px" }}>✕</button>
            </div>}
            {items.map(function (item) {
              return <InvItem key={item.name} item={item} onTog={function () { ti(tab, cat, item.name); }} onStar={function () { tsp(tab, cat, item.name); }} onTogPB={function () { tp(tab, cat, item.name); }} onTogUtensil={function () { tu(tab, cat, item.name); }}
                onDel={function () { ri(cat, item.name); }}
                onRename={function (n) { rn(tab, cat, item.name, n); }}
                onFlagNew={function (d) { fn(tab, cat, item.name, d); }}
                expanded={expandedItem === item.name + ":" + cat}
                onExpand={function (v) { setExpandedItem(v ? item.name + ":" + cat : null); }} />;
            })}
            {del === "cat:" + cat && <div style={{ display: "flex", gap: 8, alignItems: "center", padding: "8px 0" }}>
              <span style={{ fontSize: 13, color: "#991B1B", fontWeight: 600 }}>Delete "{cat}"?</span>
              <button onClick={function () { rc(cat); }} style={{ ...S.mini, backgroundColor: "#DC2626", color: "#fff" }}>Yes</button>
              <button onClick={function () { setDel(null); }} style={{ ...S.mini, backgroundColor: "#f3f4f6", color: "#666" }}>Cancel</button>
            </div>}
          </div>);
        })}
        {!addCat && <button onClick={function () { setAddCat(true); setNc(""); }} style={{ width: "100%", padding: 14, borderRadius: 12, border: "2px dashed #d1d5db", backgroundColor: "transparent", fontSize: 14, fontWeight: 700, color: "#888", cursor: "pointer" }}>+ Add category</button>}
        {addCat && <div style={{ display: "flex", gap: 8 }}>
          <input type="text" placeholder="Category name..." value={nc} onChange={function (e) { setNc(e.target.value); }} onKeyDown={function (e) { if (e.key === "Enter") ac(); }} autoFocus style={{ ...S.sInput, flex: 1 }} />
          <button onClick={ac} style={{ ...S.mini, backgroundColor: "#10B981", color: "#fff", padding: "8px 16px" }}>Add</button>
          <button onClick={function () { setAddCat(false); }} style={{ ...S.mini, backgroundColor: "#f3f4f6", color: "#666", padding: "8px 12px" }}>✕</button>
        </div>}
      </>}
    </div>
  </div>);
}

/* ── DASHBOARD ── */
function Dash({ kids, ts, onDeleteKidOrder, onBack, saveTs, menu, calendar }) {
  const [confirmDel, setConfirmDel] = useState(null);
  var ds = orderDateLabel();

  // Look up utensil for an item name across all menu sections
  function getUtensil(itemName) {
    if (!menu) return null;
    var sections = ["Breakfast", "Lunch", "Snacks"];
    for (var si = 0; si < sections.length; si++) {
      var sec = menu[sections[si]];
      if (!sec) continue;
      var cats = Object.keys(sec);
      for (var ci = 0; ci < cats.length; ci++) {
        var items = sec[cats[ci]];
        for (var ii = 0; ii < items.length; ii++) {
          if (items[ii].name === itemName && items[ii].utensil) return items[ii].utensil;
        }
      }
    }
    return null;
  }

  function togglePrep(kidId, meal, item) {
    var base = freshTs(ts);
    var kidData = base[kidId];
    if (!kidData) return;
    var prepped = kidData.prepped ? Object.assign({}, kidData.prepped) : {};
    var key = meal + ":" + item;
    if (prepped[key]) { delete prepped[key]; } else { prepped[key] = true; }
    var newTs = Object.assign({}, base);
    newTs[kidId] = Object.assign({}, kidData, { prepped: prepped });
    saveTs(newTs).catch(function (e) { console.error("prep save failed", e); });
  }

  function isPrepped(kidId, meal, item) {
    var kidData = ts[kidId];
    if (!kidData || !kidData.prepped) return false;
    return !!kidData.prepped[meal + ":" + item];
  }

  return (<div style={S.dCtr}><div style={S.sHdr}>
    <button onClick={onBack} style={S.back}>← Home</button>
    <div style={{ fontSize: 24, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>📋 Today's Menu</div>
    <div style={{ fontSize: 14, color: "#888" }}>{ds}</div>
  </div>
  <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>{kids.map(function (k) {
    var s = ts[k.id];
    var lp = lunchProvidedFor(calendar, k.id);
    var asn = afterSchoolFor(calendar, k.id);
    if (!s) return (<div key={k.id} style={{ padding: 20, borderRadius: 16, backgroundColor: "#f9fafb", border: "2px dashed #e5e7eb", textAlign: "center" }}>
      <Avatar kid={k} size={48} /><div style={{ fontSize: 16, fontWeight: 700, color: "#9ca3af", fontFamily: "'Fredoka', sans-serif", marginTop: 8 }}>{k.name} — not yet</div></div>);
    var asItems = s.afterSchool || [];
    // After-school block sits under Breakfast/Lunch inside the grid; Snacks spans both rows
    var showAs = asItems.length > 0 || !!asn;
    var allItems = [].concat((s.breakfast || []).map(function (i) { return { meal: "breakfast", name: i }; }))
      .concat((s.lunch || []).map(function (i) { return { meal: "lunch", name: i }; }))
      .concat((s.snacks || []).map(function (i) { return { meal: "snacks", name: i }; }))
      .concat(asItems.map(function (i) { return { meal: "afterSchool", name: i }; }));
    var totalPrepped = allItems.filter(function (i) { return isPrepped(k.id, i.meal, i.name); }).length;
    // Count lunch provided as prepped if applicable
    var lpCount = lp && (!s.lunch || !s.lunch.length) ? 1 : 0;
    var totalItems = allItems.length + lpCount;
    var totalDone = totalPrepped + lpCount;
    var allDone = totalDone === totalItems && totalItems > 0;
    // Collect utensils needed
    var utensils = { fork: false, spoon: false };
    allItems.forEach(function (i) {
      var u = getUtensil(i.name);
      if (u === "fork" || u === "both") utensils.fork = true;
      if (u === "spoon" || u === "both") utensils.spoon = true;
    });
    var utensilLabel = utensils.fork && utensils.spoon ? "🍴🥄 Fork + Spoon" : utensils.fork ? "🍴 Fork" : utensils.spoon ? "🥄 Spoon" : null;
    return (<div key={k.id} style={{ padding: 20, borderRadius: 16, backgroundColor: allDone ? "#F0FDF4" : "#fff", boxShadow: "0 2px 12px rgba(0,0,0,.06)", border: "2px solid " + (allDone ? "#10B981" : k.color + "30") }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <Avatar kid={k} size={44} />
        <div style={{ flex: 1 }}><div style={{ fontSize: 18, fontWeight: 700, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>{k.name} {allDone ? "✅" : ""}</div>
          <div style={{ fontSize: 12, color: "#10B981", fontWeight: 600 }}>{s.updated ? "Updated" : "Done"} {fTime(s.completedAt)} · {totalDone}/{totalItems} prepped</div>
          {utensilLabel && <div style={{ fontSize: 12, fontWeight: 700, color: "#3B82F6", marginTop: 2 }}>Pack: {utensilLabel}</div>}
        </div>
        {confirmDel === k.id
          ? <div style={{ display: "flex", gap: 6 }}>
              <button onClick={function () { onDeleteKidOrder(k.id); setConfirmDel(null); }} style={{ padding: "4px 12px", borderRadius: 8, border: "none", backgroundColor: "#DC2626", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Delete</button>
              <button onClick={function () { setConfirmDel(null); }} style={{ padding: "4px 12px", borderRadius: 8, border: "none", backgroundColor: "#f3f4f6", color: "#666", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Cancel</button>
            </div>
          : <button onClick={function () { setConfirmDel(k.id); }} style={{ minWidth: 44, minHeight: 44, padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 8, border: "none", backgroundColor: "transparent", color: "#ccc", fontSize: 16, cursor: "pointer" }}>🗑️</button>
        }
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gridTemplateRows: showAs ? "auto 1fr" : undefined, gap: 12 }}>
        {[{ l: "🍳 Breakfast", m: "breakfast", i: s.breakfast }, { l: "🥪 Lunch", m: "lunch", i: s.lunch }, { l: "🍎 Snacks", m: "snacks", i: s.snacks }].map(function (x) {
          var lpForMeal = x.m === "lunch" && lp && (!x.i || !x.i.length);
          return (<div key={x.l} style={showAs && x.m === "snacks" ? { gridRow: "1 / 3" } : undefined}><div style={{ fontSize: 12, fontWeight: 700, color: "#888", marginBottom: 4 }}>{x.l}</div>
            {lpForMeal && <div style={{ fontSize: 14, fontWeight: 600, color: "#10B981", padding: "8px 12px", marginBottom: 4, borderRadius: 10, backgroundColor: "#D1FAE5", textDecoration: "line-through" }}>🎉 {lp.label || "Lunch Provided"}</div>}
            {(x.i || []).map(function (it) {
              var done = isPrepped(k.id, x.m, it);
              var u = getUtensil(it);
              var uIcon = u === "fork" ? " 🍴" : u === "spoon" ? " 🥄" : u === "both" ? " 🍴🥄" : "";
              return <div key={it} onClick={function () { togglePrep(k.id, x.m, it); }}
                style={{ fontSize: 15, fontWeight: 500, color: done ? "#10B981" : "#374151", padding: "12px 14px", marginBottom: 4, borderRadius: 10, backgroundColor: done ? "#D1FAE5" : "#f9fafb", textDecoration: done ? "line-through" : "none", cursor: "pointer", transition: "all .15s" }}>{it}{uIcon}</div>;
            })}</div>);
        })}
        {showAs && <div style={{ gridColumn: "1 / 3", gridRow: "2", alignSelf: "start", marginTop: 4 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#3B82F6", marginBottom: 4 }}>🎒 After School{asn && asn.label ? " · " + asn.label : ""}</div>
          {asItems.length === 0
            ? <div style={{ fontSize: 14, color: "#60A5FA", fontStyle: "italic" }}>Not picked yet, add one when packing</div>
            : asItems.map(function (it) {
                var done = isPrepped(k.id, "afterSchool", it);
                var u = getUtensil(it);
                var uIcon = u === "fork" ? " 🍴" : u === "spoon" ? " 🥄" : u === "both" ? " 🍴🥄" : "";
                return <div key={it} onClick={function () { togglePrep(k.id, "afterSchool", it); }}
                  style={{ fontSize: 15, fontWeight: 500, color: done ? "#10B981" : "#374151", padding: "12px 14px", marginBottom: 4, borderRadius: 10, backgroundColor: done ? "#D1FAE5" : "#EFF6FF", textDecoration: done ? "line-through" : "none", cursor: "pointer", transition: "all .15s" }}>{it}{uIcon}</div>;
              })}
        </div>}
      </div>
    </div>);
  })}</div></div>);
}

/* ── GROCERY LIST ── */
function Grocery({ menu, onSave, onBack }) {
  const [checked, setChecked] = useState({});
  var unavail = [];
  Object.keys(menu).forEach(function (mt) {
    Object.keys(menu[mt]).forEach(function (cat) {
      menu[mt][cat].forEach(function (item) {
        if (!item.available && !item.special) {
          unavail.push({ name: item.name, category: cat, meal: mt });
        }
      });
    });
  });
  var grouped = {};
  unavail.forEach(function (item) {
    var key = item.meal;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(item);
  });
  var mealIcons = { Breakfast: "🍳", Lunch: "🥪", Snacks: "🍎" };

  function toggleBought(item) {
    var k = item.meal + ":" + item.category + ":" + item.name;
    var wasChecked = checked[k];
    var newChecked = Object.assign({}, checked);
    if (wasChecked) { delete newChecked[k]; } else { newChecked[k] = true; }
    setChecked(newChecked);
    // Toggle availability in menu
    var m = JSON.parse(JSON.stringify(menu));
    m[item.meal][item.category] = m[item.meal][item.category].map(function (i) {
      return i.name === item.name ? Object.assign({}, i, { available: !wasChecked }) : i;
    });
    onSave(m);
  }

  var remainCount = unavail.filter(function (item) { return !checked[item.meal + ":" + item.category + ":" + item.name]; }).length;

  return (<div style={S.dCtr}><div style={S.sHdr}>
    <button onClick={onBack} style={S.back}>← Home</button>
    <div style={{ fontSize: 24, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>🛍️ Grocery List</div>
    <div style={{ fontSize: 13, color: "#888" }}>{remainCount} items to buy</div>
  </div>
  <div style={{ padding: 16 }}>
    {unavail.length === 0 && <div style={{ textAlign: "center", padding: 40, color: "#888" }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
      <div style={{ fontSize: 18, fontWeight: 700, fontFamily: "'Fredoka', sans-serif" }}>All stocked up!</div>
    </div>}
    {Object.keys(grouped).map(function (mt) {
      return (<div key={mt} style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#374151", marginBottom: 8, fontFamily: "'Fredoka', sans-serif" }}>{mealIcons[mt] || ""} {mt}</div>
        {grouped[mt].map(function (item) {
          var k = item.meal + ":" + item.category + ":" + item.name;
          var bought = checked[k];
          return (<button key={k} onClick={function () { toggleBought(item); }} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", marginBottom: 4, borderRadius: 12, backgroundColor: bought ? "#D1FAE5" : "#fff", border: "none", width: "100%", cursor: "pointer", textAlign: "left", transition: "all .2s" }}>
            <div>
              <div style={{ fontSize: 15, fontWeight: 600, color: bought ? "#065F46" : "#374151", textDecoration: bought ? "line-through" : "none" }}>{item.name}</div>
              <div style={{ fontSize: 12, color: bought ? "#6EE7B7" : "#bbb" }}>{item.category}</div>
            </div>
            <div style={{ fontSize: 20 }}>{bought ? "✅" : "☐"}</div>
          </button>);
        })}
      </div>);
    })}
  </div></div>);
}

/* ── HISTORY ── */
function History({ kids, hist, menu, onDeleteDay, onBack }) {
  const [tab, setTab] = useState("days");
  const [confirmDel, setConfirmDel] = useState(null);
  var daySet = {};
  kids.forEach(function (kid) {
    (hist[kid.id] || []).forEach(function (entry) {
      if (!daySet[entry.date]) daySet[entry.date] = {};
      daySet[entry.date][kid.id] = entry;
    });
  });
  var days = Object.keys(daySet).sort().reverse().slice(0, 14);

  // Stats computation
  function getStats(kidId) {
    var entries = hist[kidId] || [];
    var counts = {};
    entries.forEach(function (e) {
      ["breakfast", "lunch", "snacks"].forEach(function (mt) {
        (e[mt] || []).forEach(function (name) { counts[name] = (counts[name] || 0) + 1; });
      });
    });
    var sorted = Object.keys(counts).map(function (name) { return { name: name, count: counts[name] }; });
    sorted.sort(function (a, b) { return b.count - a.count; });
    return { counts: counts, sorted: sorted, totalDays: entries.length };
  }

  function getNeverPicked() {
    var allPicked = {};
    kids.forEach(function (kid) {
      (hist[kid.id] || []).forEach(function (e) {
        ["breakfast", "lunch", "snacks"].forEach(function (mt) {
          (e[mt] || []).forEach(function (name) { allPicked[name] = true; });
        });
      });
    });
    var never = [];
    Object.keys(menu).forEach(function (mt) {
      Object.keys(menu[mt]).forEach(function (cat) {
        menu[mt][cat].forEach(function (item) {
          if (!allPicked[item.name]) never.push({ name: item.name, category: cat, meal: mt });
        });
      });
    });
    return never;
  }

  return (<div style={S.dCtr}><div style={S.sHdr}>
    <button onClick={onBack} style={S.back}>← Home</button>
    <div style={{ fontSize: 24, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>📊 History</div>
  </div>
  <div style={S.tRow}>
    <button onClick={function () { setTab("days"); }} style={{ ...S.tab, backgroundColor: tab === "days" ? "#1a1a2e" : "transparent", color: tab === "days" ? "#fff" : "#666" }}>📅 Days</button>
    <button onClick={function () { setTab("stats"); }} style={{ ...S.tab, backgroundColor: tab === "stats" ? "#1a1a2e" : "transparent", color: tab === "stats" ? "#fff" : "#666" }}>📊 Stats</button>
  </div>
  <div style={{ padding: 16 }}>

    {tab === "days" && <>
    {days.length === 0 && <div style={{ textAlign: "center", padding: 40, color: "#888" }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>📭</div>
      <div style={{ fontSize: 18, fontWeight: 700, fontFamily: "'Fredoka', sans-serif" }}>No history yet</div>
    </div>}
    {days.map(function (date) {
      var dayData = daySet[date];
      var d = new Date(date + "T12:00:00");
      var label = d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
      return (<div key={date} style={{ marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "2px solid #e5e7eb", paddingBottom: 6, marginBottom: 8 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#374151", fontFamily: "'Fredoka', sans-serif" }}>{label}</div>
          {confirmDel === date
            ? <div style={{ display: "flex", gap: 6 }}>
                <button onClick={function () { onDeleteDay(date); setConfirmDel(null); }} style={{ padding: "4px 12px", borderRadius: 8, border: "none", backgroundColor: "#DC2626", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Delete</button>
                <button onClick={function () { setConfirmDel(null); }} style={{ padding: "4px 12px", borderRadius: 8, border: "none", backgroundColor: "#f3f4f6", color: "#666", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Cancel</button>
              </div>
            : <button onClick={function () { setConfirmDel(date); }} style={{ minWidth: 44, minHeight: 44, padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 8, border: "none", backgroundColor: "transparent", color: "#ccc", fontSize: 16, cursor: "pointer" }}>🗑️</button>
          }
        </div>
        {kids.map(function (kid) {
          var entry = dayData[kid.id];
          if (!entry) return (<div key={kid.id} style={{ fontSize: 13, color: "#bbb", marginBottom: 6, paddingLeft: 8 }}>{kid.emoji} {kid.name} — no order</div>);
          return (<div key={kid.id} style={{ marginBottom: 8, padding: "10px 12px", borderRadius: 12, backgroundColor: "#fff", border: "1px solid " + kid.color + "20" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#1a1a2e", marginBottom: 4 }}>{kid.emoji} {kid.name}</div>
            <div style={{ fontSize: 13, color: "#666" }}>
              <span style={{ fontWeight: 600 }}>🍳</span> {(entry.breakfast || []).join(", ") || "—"}
              <span style={{ margin: "0 8px", color: "#ddd" }}>|</span>
              <span style={{ fontWeight: 600 }}>🥪</span> {(entry.lunch || []).join(", ") || "—"}
              <span style={{ margin: "0 8px", color: "#ddd" }}>|</span>
              <span style={{ fontWeight: 600 }}>🍎</span> {(entry.snacks || []).join(", ") || "—"}
            </div>
            {entry.afterSchool && entry.afterSchool.length > 0 && <div style={{ fontSize: 12, color: "#3B82F6", fontWeight: 600, marginTop: 4 }}>🎒 {entry.afterSchool.join(", ")}</div>}
          </div>);
        })}
      </div>);
    })}
    </>}

    {tab === "stats" && <>
      {kids.map(function (kid) {
        var stats = getStats(kid.id);
        if (!stats.totalDays) return (<div key={kid.id} style={{ marginBottom: 20, padding: 16, backgroundColor: "#fff", borderRadius: 12 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{kid.emoji} {kid.name}</div>
          <div style={{ fontSize: 13, color: "#bbb", marginTop: 4 }}>No orders yet</div>
        </div>);
        var top = stats.sorted.slice(0, 7);
        return (<div key={kid.id} style={{ marginBottom: 20, padding: 16, backgroundColor: "#fff", borderRadius: 12, border: "1px solid " + kid.color + "20" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
            <Avatar kid={kid} size={32} />
            <div>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{kid.name}</div>
              <div style={{ fontSize: 12, color: "#888" }}>{stats.totalDays} days tracked</div>
            </div>
          </div>
          <div style={S.cLbl}>⭐ Most Picked</div>
          {top.map(function (item, i) {
            var pct = Math.round(item.count / stats.totalDays * 100);
            return (<div key={item.name} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
              <span style={{ fontSize: 13, color: "#888", minWidth: 18, textAlign: "right" }}>{i + 1}.</span>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>{item.name}</span>
                  <span style={{ fontSize: 12, color: "#888" }}>{item.count}x ({pct}%)</span>
                </div>
                <div style={{ height: 6, borderRadius: 3, backgroundColor: "#f3f4f6" }}>
                  <div style={{ height: 6, borderRadius: 3, backgroundColor: kid.color, width: pct + "%", transition: "width .3s" }} />
                </div>
              </div>
            </div>);
          })}
        </div>);
      })}

      <div style={{ marginTop: 8 }}>
        <div style={S.cLbl}>🚫 Never Picked</div>
        {getNeverPicked().length === 0 && <div style={{ fontSize: 13, color: "#888", padding: 8 }}>Every item has been picked at least once!</div>}
        {getNeverPicked().map(function (item) {
          return (<div key={item.name + item.meal} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", marginBottom: 3, borderRadius: 10, backgroundColor: "#fff" }}>
            <span style={{ fontSize: 14, fontWeight: 500, color: "#9ca3af" }}>{item.name}</span>
            <span style={{ fontSize: 11, color: "#ccc" }}>{item.meal} · {item.category}</span>
          </div>);
        })}
      </div>
    </>}

  </div></div>);
}

/* ── SETTINGS ── */
function Sett({ kids, rules, notif, settings, calendar, menu, saveKids, saveRules, saveNotif, saveSettings, saveCalendar, onBack }) {
  const [sec, setSec] = useState("rules");
  const [lk, _setLk] = useState(kids);
  const [lr, _setLr] = useState(rules);
  const [ln, _setLn] = useState(notif);
  const [ls, _setLs] = useState(settings);
  const [lc, _setLc] = useState(calendar);
  const fRef = useRef(null);
  const [upIdx, setUpIdx] = useState(null);
  const [trustExp, setTrustExp] = useState(trustUntil());
  const [copied, setCopied] = useState(false);
  const [showPast, setShowPast] = useState(false);
  const [confirmPastDel, setConfirmPastDel] = useState(false);
  const [chooserOpen, setChooserOpen] = useState(false);
  const [addType, setAddType] = useState(null);
  const [justAdded, setJustAdded] = useState(false);
  const [showLater, setShowLater] = useState(false);
  const pendRef = useRef({});

  // Calendar: one aggregated list across the three entry types. Special days
  // are annual MM-DD and resolve to their next occurrence on/after the
  // ordering date; free lunch and after-school days carry full dates.
  var CAL_TYPES = {
    lp: { field: "lunchProvided", emoji: "🎉", accent: "#10B981", name: "Free lunch day", help: "Selected kids get lunch provided that day and only need to pick at least 1 snack." },
    as: { field: "afterSchool", emoji: "🎒", accent: "#3B82F6", name: "After-school snack day", help: "Selected kids pick one extra snack that gets packed separately for their activity." },
    sp: { field: "dates", emoji: "⭐", accent: "#F59E0B", name: "Special item day", help: "Unlocks ⭐ items in Inventory on this date every year." }
  };
  var ordToday = today();
  var ordMd = ordToday.slice(5), ordYear = parseInt(ordToday.slice(0, 4), 10);
  function byDate(a, b) { return a.date < b.date ? -1 : a.date > b.date ? 1 : 0; }
  var calRows = [];
  (lc.lunchProvided || []).forEach(function (e) { calRows.push({ type: "lp", date: e.date, entry: e }); });
  (lc.afterSchool || []).forEach(function (e) { calRows.push({ type: "as", date: e.date, entry: e }); });
  (lc.dates || []).forEach(function (d) {
    var md = typeof d === "string" ? d : d.date;
    var p = md.split("-");
    calRows.push({ type: "sp", date: ymdOf(md >= ordMd ? ordYear : ordYear + 1, parseInt(p[0], 10), parseInt(p[1], 10)), entry: d });
  });
  var upcoming = calRows.filter(function (r) { return r.date >= ordToday; }).sort(byDate);
  // Upcoming shows the next 30 days by default; the rest sits behind "Show N more"
  var p0 = ordToday.split("-");
  var cutD = new Date(parseInt(p0[0], 10), parseInt(p0[1], 10) - 1, parseInt(p0[2], 10));
  cutD.setDate(cutD.getDate() + 30);
  var nearCut = ymdOf(cutD.getFullYear(), cutD.getMonth() + 1, cutD.getDate());
  var nearRows = upcoming.filter(function (r) { return r.date <= nearCut; });
  var laterRows = upcoming.filter(function (r) { return r.date > nearCut; });
  var pastRows = calRows.filter(function (r) { return r.type !== "sp" && r.date < ordToday; }).sort(byDate).reverse();
  function kidNamesFor(e) {
    if (!e.kids || !e.kids.length) return "All kids";
    return kids.filter(function (k) { return e.kids.indexOf(k.id) >= 0; }).map(function (k) { return k.emoji + " " + k.name; }).join(", ");
  }
  // Removal is by object identity within the entry's own array, never by index into a sorted copy
  function removeRow(r) { var f = CAL_TYPES[r.type].field; setLc(Object.assign({}, lc, { [f]: (lc[f] || []).filter(function (x) { return x !== r.entry; }) })); }
  function removePast() {
    setLc(Object.assign({}, lc, {
      lunchProvided: (lc.lunchProvided || []).filter(function (x) { return x.date >= ordToday; }),
      afterSchool: (lc.afterSchool || []).filter(function (x) { return x.date >= ordToday; })
    }));
    setConfirmPastDel(false);
  }
  function addEntries(field, items) {
    setLc(Object.assign({}, lc, { [field]: (lc[field] || []).concat(items) }));
    setAddType(null);
    setJustAdded(true);
    setTimeout(function () { setJustAdded(false); }, 1500);
  }
  var xBtn = { minWidth: 44, minHeight: 44, padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 10, border: "none", backgroundColor: "#FEE2E2", color: "#DC2626", fontSize: 16, fontWeight: 700, cursor: "pointer", flexShrink: 0 };
  function calRow(r, i, dim) {
    var t = CAL_TYPES[r.type];
    var label = typeof r.entry === "string" ? "" : (r.entry.label || "");
    var sub = r.type === "sp" ? "Repeats every year" : kidNamesFor(r.entry);
    return <div key={r.type + "|" + r.date + "|" + label + "#" + i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 8px 8px 12px", marginBottom: 6, borderRadius: 12, backgroundColor: "#fff", borderLeft: "3px solid " + t.accent, opacity: dim ? 0.6 : 1 }}>
      <div style={{ flex: 1 }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: "#374151" }}>{t.emoji} {fmtYmd(r.date)}</span>
        {label && <span style={{ fontSize: 13, color: "#888" }}> — {label}</span>}
        <div style={{ fontSize: 12, color: t.accent, fontWeight: 600, marginTop: 2 }}>{sub}</div>
      </div>
      <button onClick={function () { removeRow(r); }} style={xBtn}>✕</button>
    </div>;
  }
  var chooserBtn = { width: "100%", minHeight: 56, padding: "14px 16px", borderRadius: 14, border: "2px solid #e5e7eb", backgroundColor: "#fff", fontSize: 17, fontWeight: 700, color: "#1a1a2e", cursor: "pointer", fontFamily: "'Fredoka', sans-serif", textAlign: "left", marginBottom: 8 };
  // Second modal of the add flow: the CalendarForm for the chosen type, in a
  // card that scrolls internally so tall forms work on phones
  function renderAddModal() {
    var t = CAL_TYPES[addType];
    var lpDates = (lc.lunchProvided || []).map(function (e) { return e.date; });
    var asDates = (lc.afterSchool || []).map(function (e) { return e.date; });
    var spDates = (lc.dates || []).map(function (d) { return typeof d === "string" ? d : d.date; });
    return <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 12 }}>
      <div style={{ backgroundColor: "#fff", borderRadius: 20, width: "100%", maxWidth: 480, maxHeight: "92vh", overflowY: "auto", WebkitOverflowScrolling: "touch", padding: "16px 16px 20px", border: "2px solid " + t.accent, boxShadow: "0 12px 40px rgba(0,0,0,0.3)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <button onClick={function () { setAddType(null); setChooserOpen(true); }} style={{ background: "none", border: "none", minHeight: 44, padding: "0 6px", fontSize: 14, fontWeight: 700, color: "#888", cursor: "pointer", fontFamily: "'Nunito', sans-serif", flexShrink: 0 }}>‹ Back</button>
        <div style={{ flex: 1, fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{t.emoji} {t.name}</div>
        <button onClick={function () { setAddType(null); }} style={{ minWidth: 44, minHeight: 44, padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 10, border: "none", backgroundColor: "#f3f4f6", color: "#666", fontSize: 18, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}>✕</button>
      </div>
      <div style={{ fontSize: 13, color: "#888", marginBottom: 12 }}>{t.help}</div>
      {addType === "lp" && <CalendarForm kids={kids} dateMode="ymd" existing={lpDates} disablePast={true} defaultAllKids={false} labelPlaceholder="e.g. Pizza Day, Field Trip" noun="free lunch day" accent={t.accent}
        onAdd={function (dates, label, kidIds) { addEntries("lunchProvided", dates.map(function (d) { return { date: d, label: label, kids: kidIds }; })); }} />}
      {addType === "as" && <CalendarForm kids={kids} dateMode="ymd" existing={asDates} disablePast={true} defaultAllKids={false} repeat={true} labelPlaceholder="e.g. Soccer, Piano, CCD" noun="after-school snack day" accent={t.accent}
        onAdd={function (dates, label, kidIds) { addEntries("afterSchool", dates.map(function (d) { return { date: d, label: label, kids: kidIds }; })); }} />}
      {addType === "sp" && <CalendarForm dateMode="md" existing={spDates} disablePast={false} labelPlaceholder="e.g. Sophia's Birthday" noun="special day" accent={t.accent}
        onAdd={function (dates, label) { addEntries("dates", dates.map(function (d) { return { date: d, label: label }; })); }} />}
      </div>
    </div>;
  }

  var devTrusted = !!(ls.password && trustExp && trustExp > Date.now() && isTrusted(ls.password));
  var unlockLink = window.location.origin + "/?unlock=" + (ls.password || "");
  function copyLink() {
    try {
      navigator.clipboard.writeText(unlockLink).then(function () {
        setCopied(true);
        setTimeout(function () { setCopied(false); }, 2000);
      }).catch(function (e) { console.error("copy failed", e); });
    } catch (e) { console.error("copy failed", e); }
  }

  // Debounced persist: text inputs fire onChange per keystroke, and writing a
  // Firestore doc per character floods the network and can land out of order.
  // Local state updates instantly; the save runs after 600ms of quiet.
  function debSave(key, fn, val) {
    var pend = pendRef.current;
    if (pend[key]) clearTimeout(pend[key].t);
    pend[key] = { fn: fn, val: val, t: setTimeout(function () { delete pend[key]; fn(val); }, 600) };
  }
  // Flush pending saves when leaving Settings (or when the tab/PWA is being
  // hidden or closed) so nothing typed is lost
  function flushPending() {
    var pend = pendRef.current;
    Object.keys(pend).forEach(function (k) { clearTimeout(pend[k].t); pend[k].fn(pend[k].val); });
    pendRef.current = {};
  }
  useEffect(function () {
    window.addEventListener("pagehide", flushPending);
    return function () {
      window.removeEventListener("pagehide", flushPending);
      flushPending();
    };
  }, []);

  // Auto-save wrappers: update local state + persist to Firestore
  function setLk(v) { var val = typeof v === "function" ? v(lk) : v; _setLk(val); debSave("kids", saveKids, val); }
  function setLr(v) { var val = typeof v === "function" ? v(lr) : v; _setLr(val); debSave("rules", saveRules, val); }
  function setLn(v) { var val = typeof v === "function" ? v(ln) : v; _setLn(val); debSave("notif", saveNotif, val); }
  function setLs(v) { var val = typeof v === "function" ? v(ls) : v; _setLs(val); debSave("set", saveSettings, val); }
  function setLc(v) { var val = typeof v === "function" ? v(lc) : v; _setLc(val); debSave("cal", saveCalendar, val); }

  function resizeImage(dataUrl, maxSize, callback) {
    var img = new Image();
    img.onload = function () {
      var canvas = document.createElement("canvas");
      var w = img.width, h = img.height;
      if (w > h) { if (w > maxSize) { h = h * maxSize / w; w = maxSize; } }
      else { if (h > maxSize) { w = w * maxSize / h; h = maxSize; } }
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      callback(canvas.toDataURL("image/jpeg", 0.7));
    };
    img.src = dataUrl;
  }

  function handleImg(e) {
    var f = e.target.files && e.target.files[0]; if (!f || upIdx === null) return;
    var r = new FileReader();
    r.onload = function (ev) {
      resizeImage(ev.target.result, 128, function (resized) {
        var c = lk.slice(); c[upIdx] = Object.assign({}, c[upIdx], { image: resized }); setLk(c);
      });
    };
    r.readAsDataURL(f); e.target.value = "";
  }

  return (<div style={S.sCtr}><div style={S.sHdr}>
    <button onClick={onBack} style={S.back}>← Home</button>
    <div style={{ fontSize: 24, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>⚙️ Settings</div>
  </div>
  <input type="file" accept="image/*" ref={fRef} style={{ display: "none" }} onChange={handleImg} />
  <div style={{ ...S.tRow, flexWrap: "wrap" }}>
    {[{ k: "rules", l: "📏 Rules" }, { k: "cal", l: "📅 Calendar" }, { k: "notifs", l: "🔔 Alerts" }, { k: "sec", l: "🔒 Security" }, { k: "kids", l: "👧 Kids" }, { k: "about", l: "ℹ️ About" }].map(function (t) {
      return <button key={t.k} onClick={function () { setSec(t.k); setShowLater(false); }} style={{ ...S.tab, flex: "none", padding: "8px 14px", backgroundColor: sec === t.k ? "#1a1a2e" : "transparent", color: sec === t.k ? "#fff" : "#666" }}>{t.l}</button>;
    })}
  </div>
  <div style={{ padding: 16, flex: 1, overflowY: "auto" }}>
    {sec === "kids" && lk.map(function (kid, idx) {
      return (<div key={kid.id} style={{ marginBottom: 24, padding: 16, borderRadius: 16, backgroundColor: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,.04)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
          <div style={{ position: "relative" }}>
            <Avatar kid={kid} size={72} />
            <button onClick={function () { setUpIdx(idx); if (fRef.current) fRef.current.click(); }} style={{ position: "absolute", bottom: -4, right: -4, width: 28, height: 28, borderRadius: "50%", border: "2px solid #fff", backgroundColor: "#3B82F6", color: "#fff", fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>📷</button>
          </div>
          <div style={{ flex: 1 }}><label style={S.sLbl}>Name</label>
            <input type="text" value={kid.name} onChange={function (e) { var c = lk.slice(); c[idx] = Object.assign({}, c[idx], { name: e.target.value }); setLk(c); }} style={S.sInput} /></div>
        </div>
        {kid.image && <button onClick={function () { var c = lk.slice(); c[idx] = Object.assign({}, c[idx], { image: null }); setLk(c); }} style={{ ...S.mini, backgroundColor: "#FEE2E2", color: "#991B1B", marginBottom: 12 }}>Remove photo</button>}
        <div style={{ marginBottom: 12 }}>
          <label style={S.sLbl}>Emoji</label>
          <select value={kid.emoji} onChange={function (e) { var c = lk.slice(); c[idx] = Object.assign({}, c[idx], { emoji: e.target.value }); setLk(c); }}
            style={{ ...S.sInput, fontSize: 16 }}>
            {EMOJI_LIST.map(function (em) {
              return <option key={em} value={em}>{em} — {EMOJIS[em]}</option>;
            })}
          </select>
        </div>
        <div>
          <label style={S.sLbl}>Color</label>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", backgroundColor: kid.color, border: "2px solid #e5e7eb", flexShrink: 0 }} />
            <select value={kid.color} onChange={function (e) { var cp = lk.slice(); cp[idx] = Object.assign({}, cp[idx], { color: e.target.value }); setLk(cp); }}
              style={{ ...S.sInput, flex: 1, fontSize: 15 }}>
              {COLOR_LIST.map(function (c) {
                return <option key={c} value={c}>{COLORS[c]}</option>;
              })}
            </select>
          </div>
        </div>
      </div>);
    })}

    {sec === "rules" && <div>
      <div style={S.cLbl}>🍱 Meal Picks</div>
      {[
        { k: "breakfastCount", l: "Breakfast picks", mn: 1, mx: 3 },
        { k: "lunchCount", l: "Lunch picks", mn: 1, mx: 3 },
        { k: "snackCount", l: "Max snacks per day", mn: 1, mx: 5 }
      ].map(function (r) {
        return (<div key={r.k} style={{ marginBottom: 6, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", backgroundColor: "#fff", borderRadius: 12 }}>
          <span style={{ fontSize: 15, fontWeight: 600, color: "#374151" }}>{r.l}</span>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button onClick={function () { setLr(function (p) { return Object.assign({}, p, { [r.k]: Math.max(r.mn, p[r.k] - 1) }); }); }} style={S.step}>−</button>
            <span style={{ fontSize: 18, fontWeight: 700, minWidth: 24, textAlign: "center", fontFamily: "'Fredoka', sans-serif" }}>{lr[r.k]}</span>
            <button onClick={function () { setLr(function (p) { return Object.assign({}, p, { [r.k]: Math.min(r.mx, p[r.k] + 1) }); }); }} style={S.step}>+</button>
          </div>
        </div>);
      })}
      <div style={{ fontSize: 12, color: "#888", margin: "-2px 4px 8px" }}>Kids pick 1 to {lr.snackCount}. At least {lr.minFruitVeggie} must be a fruit or veggie.</div>

      <div style={{ ...S.cLbl, marginTop: 20 }}>🍎 Snack Rules</div>
      {[
        { k: "minFruitVeggie", l: "Min fruit/veggie", mn: 0, mx: 3 },
        { k: "maxSweet", l: "Max sweet snacks", mn: 0, mx: 5 }
      ].map(function (r) {
        return (<div key={r.k} style={{ marginBottom: 6, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", backgroundColor: "#fff", borderRadius: 12 }}>
          <span style={{ fontSize: 15, fontWeight: 600, color: "#374151" }}>{r.l}</span>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button onClick={function () { setLr(function (p) { return Object.assign({}, p, { [r.k]: Math.max(r.mn, p[r.k] - 1) }); }); }} style={S.step}>−</button>
            <span style={{ fontSize: 18, fontWeight: 700, minWidth: 24, textAlign: "center", fontFamily: "'Fredoka', sans-serif" }}>{lr[r.k]}</span>
            <button onClick={function () { setLr(function (p) { return Object.assign({}, p, { [r.k]: Math.min(r.mx, p[r.k] + 1) }); }); }} style={S.step}>+</button>
          </div>
        </div>);
      })}

      <div style={{ ...S.cLbl, marginTop: 20 }}>🔁 No-Repeat Rules</div>
      <div style={{ padding: "8px 12px", backgroundColor: "#EFF6FF", borderRadius: 10, marginBottom: 10, fontSize: 13, color: "#1E40AF" }}>Block items if picked N days in a row</div>
      {[
        { key: "noRepeatBreakfast", daysKey: "noRepeatBreakfastDays", l: "Breakfast" },
        { key: "noRepeatLunch", daysKey: "noRepeatLunchDays", l: "Lunch" },
        { key: "noRepeatSnacks", daysKey: "noRepeatSnacksDays", l: "Snacks" }
      ].map(function (r) {
        var on = lr[r.key];
        return (<div key={r.key} style={{ marginBottom: 6, padding: "12px 16px", backgroundColor: "#fff", borderRadius: 12 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span style={{ fontSize: 15, fontWeight: 600, color: "#374151" }}>{r.l}</span>
            <button onClick={function () { setLr(function (p) { return Object.assign({}, p, { [r.key]: !p[r.key] }); }); }}
              style={{ width: 44, height: 26, borderRadius: 13, backgroundColor: on ? "#10B981" : "#d1d5db", position: "relative", border: "none", cursor: "pointer" }}>
              <div style={{ position: "absolute", top: 3, left: on ? 21 : 3, width: 20, height: 20, borderRadius: "50%", backgroundColor: "#fff", transition: "left .2s", boxShadow: "0 1px 3px rgba(0,0,0,.2)" }} />
            </button>
          </div>
          {on && <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 10 }}>
            <span style={{ fontSize: 13, color: "#888" }}>Days in a row:</span>
            <button onClick={function () { setLr(function (p) { return Object.assign({}, p, { [r.daysKey]: Math.max(1, p[r.daysKey] - 1) }); }); }} style={S.step}>−</button>
            <span style={{ fontSize: 18, fontWeight: 700, minWidth: 24, textAlign: "center", fontFamily: "'Fredoka', sans-serif" }}>{lr[r.daysKey]}</span>
            <button onClick={function () { setLr(function (p) { return Object.assign({}, p, { [r.daysKey]: Math.min(7, p[r.daysKey] + 1) }); }); }} style={S.step}>+</button>
          </div>}
        </div>);
      })}

      <div style={{ ...S.cLbl, marginTop: 20 }}>📊 Sort Order</div>
      <div style={{ padding: "8px 12px", backgroundColor: "#EFF6FF", borderRadius: 10, marginBottom: 10, fontSize: 13, color: "#1E40AF" }}>How items are ordered in the kiosk (personalized per kid)</div>
      <div style={{ display: "flex", gap: 8 }}>
        {[{ k: "alpha", l: "A-Z" }, { k: "30day", l: "Last 30 days" }, { k: "alltime", l: "All time" }].map(function (o) {
          var on = lr.sortOrder === o.k;
          return <button key={o.k} onClick={function () { setLr(function (p) { return Object.assign({}, p, { sortOrder: o.k }); }); }}
            style={{ flex: 1, padding: "10px 12px", borderRadius: 12, border: on ? "2px solid #1a1a2e" : "2px solid #e5e7eb", backgroundColor: on ? "#1a1a2e" : "#fff", color: on ? "#fff" : "#666", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "'Nunito', sans-serif" }}>{o.l}</button>;
        })}
      </div>
    </div>}

    {sec === "cal" && <div>
      {chooserOpen && <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 20 }}>
        <div style={{ backgroundColor: "#fff", borderRadius: 20, padding: "24px 20px", width: "100%", maxWidth: 380, boxShadow: "0 12px 40px rgba(0,0,0,0.3)" }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif", marginBottom: 14, textAlign: "center" }}>What kind of day?</div>
          {["lp", "as", "sp"].map(function (ty) {
            var t = CAL_TYPES[ty];
            return <button key={ty} onClick={function () { setChooserOpen(false); setAddType(ty); }} style={chooserBtn}>{t.emoji} {t.name}</button>;
          })}
          <button onClick={function () { setChooserOpen(false); }} style={{ width: "100%", background: "none", border: "none", minHeight: 44, fontSize: 14, fontWeight: 700, color: "#888", cursor: "pointer", fontFamily: "'Nunito', sans-serif" }}>Cancel</button>
        </div>
      </div>}
      {addType && renderAddModal()}

      <div style={S.cLbl}>📅 Calendar</div>
      <button onClick={function () { setChooserOpen(true); }} style={{ ...S.nBtn, backgroundColor: "#1a1a2e" }}>+ Add calendar item</button>
      {justAdded && <div style={{ textAlign: "center", fontSize: 13, color: "#10B981", fontWeight: 700, marginTop: 8 }}>Added ✓</div>}

      <div style={{ ...S.cLbl, marginTop: 16 }}>Upcoming</div>
      {upcoming.length === 0 && <div style={{ fontSize: 13, color: "#999", padding: "4px 0 8px" }}>Nothing scheduled yet.</div>}
      {nearRows.map(function (r, i) { return calRow(r, i, false); })}
      {showLater && laterRows.map(function (r, i) { return calRow(r, nearRows.length + i, false); })}
      {laterRows.length > 0 && <button onClick={function () { setShowLater(!showLater); }} style={{ background: "none", border: "none", minHeight: 44, padding: "0 4px", fontSize: 14, fontWeight: 700, color: "#3B82F6", cursor: "pointer", fontFamily: "'Nunito', sans-serif" }}>{showLater ? "Show less ▴" : "Show " + laterRows.length + " more ▸"}</button>}

      {pastRows.length > 0 && <div style={{ marginTop: 20 }}>
        <button onClick={function () { setShowPast(!showPast); setConfirmPastDel(false); }} style={{ ...S.mini, minHeight: 44, padding: "10px 14px", fontSize: 14, backgroundColor: "#f3f4f6", color: "#666" }}>Past dates ({pastRows.length}) {showPast ? "▾" : "▸"}</button>
        {showPast && <div style={{ marginTop: 8 }}>
          {pastRows.map(function (r, i) { return calRow(r, i, true); })}
          {confirmPastDel
            ? <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                <button onClick={removePast} style={{ ...S.mini, minHeight: 44, padding: "10px 16px", fontSize: 14, backgroundColor: "#DC2626", color: "#fff" }}>Delete {pastRows.length} past date{pastRows.length > 1 ? "s" : ""}</button>
                <button onClick={function () { setConfirmPastDel(false); }} style={{ ...S.mini, minHeight: 44, padding: "10px 16px", fontSize: 14, backgroundColor: "#f3f4f6", color: "#666" }}>Cancel</button>
              </div>
            : <button onClick={function () { setConfirmPastDel(true); }} style={{ ...S.mini, minHeight: 44, padding: "10px 16px", fontSize: 14, backgroundColor: "#FEE2E2", color: "#991B1B", marginTop: 4 }}>🗑️ Delete all past dates</button>}
        </div>}
      </div>}
    </div>}

    {sec === "notifs" && <div>
      <Tog label="🔊 Sound effects" value={ln.soundEnabled} onToggle={function () { setLn(function (n) { return Object.assign({}, n, { soundEnabled: !n.soundEnabled }); }); }} />
      <div style={{ marginTop: 16, marginBottom: 8 }}><div style={S.sLbl}>Home Assistant</div></div>
      <Tog label="🏠 HA push" value={ln.haEnabled} onToggle={function () { setLn(function (n) { return Object.assign({}, n, { haEnabled: !n.haEnabled }); }); }} />
      {ln.haEnabled && <div style={{ marginTop: 8 }}>
        <Tog label="📩 Notify per kid" value={ln.notifyPerKid} onToggle={function () { setLn(function (n) { return Object.assign({}, n, { notifyPerKid: !n.notifyPerKid }); }); }} />
        <div><label style={S.sLbl}>URL</label><input type="text" placeholder="https://your-ha.duckdns.org" value={ln.haUrl || ""} onChange={function (e) { setLn(function (n) { return Object.assign({}, n, { haUrl: e.target.value }); }); }} style={S.sInput} /></div>
      </div>}
    </div>}

    {sec === "sec" && <div>
      <div style={{ padding: "12px 16px", backgroundColor: "#EFF6FF", borderRadius: 12, marginBottom: 16, fontSize: 13, color: "#1E40AF" }}>🔒 Protects Inventory and Settings. Leave blank for no password.</div>
      <label style={S.sLbl}>Password</label>
      <input type="text" placeholder="No password" value={ls.password || ""} onChange={function (e) { setLs(function (s) { return Object.assign({}, s, { password: e.target.value }); }); }} style={S.sInput} />
      <div style={{ fontSize: 12, color: "#888", marginTop: 6 }}>Changing the PIN signs out every trusted device.</div>
      {ls.password && <button onClick={function () { setLs(function (s) { return Object.assign({}, s, { password: "" }); }); }} style={{ ...S.mini, backgroundColor: "#FEE2E2", color: "#991B1B", marginTop: 8, padding: "8px 16px", fontSize: 14 }}>🔓 Remove password</button>}

      <div style={{ ...S.cLbl, marginTop: 24 }}>📱 This device</div>
      {devTrusted
        ? <div style={{ padding: "12px 16px", backgroundColor: "#fff", borderRadius: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 8 }}>✅ Trusted until {new Date(trustExp).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</div>
            <button onClick={function () { forgetDevice(); setTrustExp(null); }} style={{ ...S.mini, minHeight: 44, padding: "10px 16px", fontSize: 14, backgroundColor: "#FEE2E2", color: "#991B1B" }}>Forget this device</button>
          </div>
        : <div style={{ padding: "12px 16px", backgroundColor: "#fff", borderRadius: 12, fontSize: 14, color: "#666" }}>This device is not trusted. Enter the PIN once to trust it for 30 days.</div>}

      {ls.password && <div style={{ marginTop: 24 }}>
        <div style={S.cLbl}>🔗 Set up another parent's phone</div>
        <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>Open this link once on their phone to trust it for 30 days. It contains the PIN, so share it privately.</div>
        <div style={{ display: "flex", gap: 8 }}>
          <input type="text" readOnly value={unlockLink} onFocus={function (e) { e.target.select(); }} style={{ ...S.sInput, flex: 1, color: "#666" }} />
          <button onClick={copyLink} style={{ ...S.mini, minHeight: 44, padding: "10px 16px", fontSize: 14, backgroundColor: copied ? "#D1FAE5" : "#1a1a2e", color: copied ? "#065F46" : "#fff" }}>{copied ? "Copied ✓" : "Copy"}</button>
        </div>
      </div>}
    </div>}

    {sec === "about" && <div>
      <div style={{ textAlign: "center", padding: "24px 16px" }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 10, marginBottom: 8 }}><BFLogo size={44} />
        <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "'Fredoka', sans-serif", color: "#1a1a2e" }}>BentoFam</div></div>
        <div style={{ fontSize: 15, color: "#888", marginBottom: 16 }}>A family meal ordering kiosk</div>
        <div style={{ display: "inline-block", padding: "8px 16px", backgroundColor: "#fff", borderRadius: 12, marginBottom: 8 }}>
          <div style={{ fontSize: 13, color: "#888" }}>Version</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{APP_VERSION}</div>
        </div>
        <div style={{ display: "inline-block", padding: "8px 16px", backgroundColor: "#fff", borderRadius: 12, marginLeft: 8 }}>
          <div style={{ fontSize: 13, color: "#888" }}>Build Date</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", fontFamily: "'Fredoka', sans-serif" }}>{APP_BUILD_DATE}</div>
        </div>
      </div>
      <div style={{ padding: "12px 16px", backgroundColor: "#f9fafb", borderRadius: 12, fontSize: 13, color: "#888", textAlign: "center" }}>
        Built with ❤️ by Jonathan & Claude · BentoFam
      </div>
      <div style={{ marginTop: 16 }}>
        <div style={S.cLbl}>📋 Release Notes</div>
        {[
          { v: "1.16.0", d: "2026-10-14", n: "Kiosk: confirm popup when a step is complete, snacks are now a max (1 to N) with fruit/veggie and 'are you done?' prompts, special-day popup shows the reason. Inventory always editable. Pinch and double-tap zoom disabled." },
          { v: "1.15.1", d: "2026-09-10", n: "Calendar: Add button at the top, Upcoming shows the next 30 days with Show more, and the whole add flow runs in popups" },
          { v: "1.15.0", d: "2026-09-10", n: "Calendar consolidated into one upcoming list with a single Add button and type chooser; kids must be chosen explicitly. After-school snack gets a kiosk popup and a tighter dashboard placement." },
          { v: "1.14.0", d: "2026-09-10", n: "After-school snacks: schedule activity days per kid (with optional weekly repeat until a date), kids pick one extra snack in the kiosk, and it shows as its own row on the dashboard with prep tracking." },
          { v: "1.13.0", d: "2026-09-10", n: "Calendar overhaul: free lunch days now carry a full date, past dates archive automatically, and adding a date is a simple three-question form with no popups. Same form for special days." },
          { v: "1.12.0", d: "2026-09-10", n: "Trusted devices: enter the parent PIN once and stay unlocked for 30 days on that device. One-time ?unlock= link for setting up another phone. Forget-this-device in Settings → Security." },
          { v: "1.11.0", d: "2026-09-09", n: "Fix 8 AM prep-tap carryover bug, failed saves now show an error instead of confetti, honest nudge status, HA token removed, merge-safe daily reset, lunch-provided snack rules cleanup, bigger tap targets" },
          { v: "1.10.3", d: "2026-07-08", n: "Cloud Scheduler now drives daily reset and late-order check directly (removes HA from the reset path). HA still handles push notifications on late-order alert via webhook." },
          { v: "1.10.2", d: "2026-07-08", n: "Adds Cloud Functions for HA integration (daily reset, late-order check) so App Check can be enforced without breaking HA" },
          { v: "1.10.1", d: "2026-07-08", n: "Adds Firebase App Check with reCAPTCHA v3 to prevent unauthorized clients from writing to Firestore" },
          { v: "1.10.0", d: "2026-07-08", n: "Removed broken email notifications, fixed stale-day carryover in long-lived sessions, no-repeat rule now checks true consecutive days, settings saves debounced" },
          { v: "1.9.1", d: "2026-04-21", n: "Fixed stale kid data carryover when one kid skips a day — wipes mm2-today on load if date doesn't match" },
          { v: "1.9.0", d: "2026-04-17", n: "BentoFam title & PWA manifest with icons, interactive mini calendar for Calendar settings" },
          { v: "1.8.1", d: "2026-04-17", n: "Fix color dropdown display" },
          { v: "1.8.0", d: "2026-04-17", n: "Utensil indicators (fork/spoon/both), bigger dashboard tap targets, free lunch in dashboard, emoji & color dropdowns with labels" },
          { v: "1.7.3", d: "2026-03-13", n: "Remove recurring special days, special dates now check ordering date instead of today" },
          { v: "1.7.2", d: "2026-03-13", n: "Prep checklist: tap items in Dashboard to mark as prepped, persists to Firestore" },
          { v: "1.7.1", d: "2026-03-13", n: "Remove app-side auto-reset — HA automation handles daily reset at 8 AM exclusively" },
          { v: "1.7.0", d: "2026-03-12", n: "8 AM day turnover: orders close, date advances, Cloud Function + HA automation for reliable reset" },
          { v: "1.6.4", d: "2026-03-12", n: "CI pipeline update: Node.js 22, latest GitHub Actions" },
          { v: "1.6.3", d: "2026-03-12", n: "Swapped button colors, Place an Order rename, calendar UX improvements, Today label" },
          { v: "1.6.2", d: "2026-03-12", n: "Auto-save in Settings — all changes save instantly, no Save button needed" },
          { v: "1.6.1", d: "2026-03-12", n: "Home screen redesign: Settings button replaces gear icon, Grocery hidden, unified button colors" },
          { v: "1.6.0", d: "2026-03-12", n: "Release notes, button colors, Calendar reorder, 8 AM reset, Firestore bulk dates" },
          { v: "1.5.5", d: "2026-03-12", n: "Auto-reset at 8 AM instead of midnight" },
          { v: "1.5.4", d: "2026-03-11", n: "Fix UTC timezone bug causing date jumps and unexpected resets" },
          { v: "1.5.3", d: "2026-03-11", n: "Fix auto-reset migration wiping orders on first deploy" },
          { v: "1.5.2", d: "2026-03-11", n: "Fix auto-reset firing mid-day due to noon rollover" },
          { v: "1.5.1", d: "2026-03-11", n: "Fix alphabetical sort in kiosk and inventory" },
          { v: "1.5.0", d: "2026-03-11", n: "Peanut butter alerts, free lunch days, avatar fix, Calendar tab, gear icon" },
          { v: "1.4.0", d: "2026-03-11", n: "BentoFam rebrand with logo" },
          { v: "1.3.2", d: "2026-03-11", n: "Delete individual kid orders from dashboard" },
          { v: "1.3.1", d: "2026-03-11", n: "Streamlined inventory edit panel with ⋯ expand" },
          { v: "1.3.0", d: "2026-03-11", n: "Manual NEW badge, stats tab in history" },
          { v: "1.2.0", d: "2026-03-11", n: "Per-meal no-repeat rules, per-kid smart sort, reorganized settings" },
          { v: "1.1.5", d: "2026-03-10", n: "HA webhook on order toggle and daily auto-reset" },
          { v: "1.1.4", d: "2026-03-10", n: "Deep linking via ?view= URL parameter" },
          { v: "1.1.3", d: "2026-03-10", n: "Fix oversized home buttons, footer anchored" },
          { v: "1.1.2", d: "2026-03-10", n: "Fix Firebase import in deployed version" },
          { v: "1.1.1", d: "2026-03-10", n: "Home screen layout, interactive grocery list, history delete" },
          { v: "1.1.0", d: "2026-03-10", n: "Home gear icon, grocery list, inventory rename, no-repeat fix" },
          { v: "1.0.9", d: "2026-03-10", n: "Fix no-repeat rule: consecutive days only" },
          { v: "1.0.8", d: "2026-03-10", n: "Fix Next/Submit button anchored to bottom" },
          { v: "1.0.7", d: "2026-03-10", n: "Widen layout for iPad, tighter button spacing" },
          { v: "1.0.6", d: "2026-03-10", n: "Fix photo avatars not persisting" },
          { v: "1.0.5", d: "2026-03-10", n: "Fix password clearing" },
          { v: "1.0.4", d: "2026-03-10", n: "Revert auto-advance, fix review layout" },
          { v: "1.0.3", d: "2026-03-10", n: "Submit button moved to top of review screen" },
          { v: "1.0.2", d: "2026-03-10", n: "Smart date (before noon=today, after noon=tomorrow)" },
          { v: "1.0.1", d: "2026-03-10", n: "Fix nudge button, Firebase import fix, toast popup" },
          { v: "1.0.0", d: "2026-03-10", n: "Initial release" },
        ].map(function (r) {
          return <div key={r.v} style={{ padding: "8px 12px", marginBottom: 4, borderRadius: 10, backgroundColor: r.v === APP_VERSION ? "#EFF6FF" : "#fff" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: r.v === APP_VERSION ? "#1E40AF" : "#374151", fontFamily: "'Fredoka', sans-serif" }}>{r.v}</span>
              <span style={{ fontSize: 11, color: "#aaa" }}>{r.d}</span>
            </div>
            <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>{r.n}</div>
          </div>;
        })}
      </div>
    </div>}
  </div>
  </div>);
}

/* ── MAIN APP ── */
export default function MealMenu() {
  const [view, setView] = useState("loading");
  const [menu, setMenu] = useState(DEF_MENU);
  const [kids, setKids] = useState(DEF_KIDS);
  const [rules, setRules] = useState(DEF_RULES);
  const [notif, setNotif] = useState(DEF_NOTIF);
  const [settings, setSettings] = useState(DEF_SET);
  const [calendar, setCalendar] = useState(DEF_CAL);
  const [hist, setHist] = useState({});
  const [ts, setTs] = useState({});
  const [orderingDate, setOrderingDate] = useState(today());
  const [confetti, setConfetti] = useState(false);

  useEffect(function () {
    (async function () {
      var r = await Promise.all([sGet(SK.menu), sGet(SK.kids), sGet(SK.rules), sGet(SK.hist), sGet(SK.today), sGet(SK.notif), sGet(SK.set), sGet(SK.cal)]);
      if (r[0]) setMenu(r[0]); if (r[1]) setKids(r[1]); if (r[3]) setHist(r[3]);
      // One-time calendar migration: free lunch days gain a full date (legacy
      // MM-DD entries map to their most recent past occurrence, which lands
      // last school year's entries in the archive) and legacy bare-string
      // special dates become { date, label } objects
      if (r[7]) {
        var cal = r[7], calChanged = false;
        if (!cal.afterSchool) cal = Object.assign({}, cal, { afterSchool: [] });
        var nowMd = realToday().slice(5), nowY = new Date().getFullYear();
        var lpMig = (cal.lunchProvided || []).map(function (lp) {
          if (!lp || typeof lp.date !== "string" || !/^\d{2}-\d{2}$/.test(lp.date)) return lp;
          calChanged = true;
          return Object.assign({}, lp, { date: (lp.date <= nowMd ? nowY : nowY - 1) + "-" + lp.date });
        });
        var datesMig = (cal.dates || []).map(function (d) {
          if (typeof d !== "string") return d;
          calChanged = true;
          return { date: d, label: "" };
        });
        if (calChanged) {
          cal = Object.assign({}, cal, { lunchProvided: lpMig, dates: datesMig });
          try { await sSet(SK.cal, cal); } catch (e) { console.error("calendar migration failed", e); }
        }
        setCalendar(cal);
      }
      // One-time migration: strip the retired HA bearer token from stored notif
      var loadedNotif = r[5] || DEF_NOTIF;
      if (loadedNotif.haToken !== undefined) {
        loadedNotif = Object.assign({}, loadedNotif);
        delete loadedNotif.haToken;
        try { await sSet(SK.notif, loadedNotif); } catch (e) { console.error("notif migration failed", e); }
      }
      setNotif(loadedNotif);
      // Migrate old rules format if needed
      var loadedRules = r[2] || DEF_RULES;
      if (loadedRules.noRepeatDays !== undefined && loadedRules.noRepeatBreakfast === undefined) {
        var oldN = loadedRules.noRepeatDays || 0;
        loadedRules = Object.assign({}, loadedRules, {
          noRepeatBreakfast: oldN > 0, noRepeatBreakfastDays: oldN || 3,
          noRepeatLunch: oldN > 0, noRepeatLunchDays: oldN || 3,
          noRepeatSnacks: oldN > 0, noRepeatSnacksDays: oldN || 3,
          sortOrder: loadedRules.sortOrder || "alpha"
        });
        delete loadedRules.noRepeatDays;
        try { await sSet(SK.rules, loadedRules); } catch (e) { console.error("rules migration failed", e); }
      }
      if (!loadedRules.sortOrder) loadedRules.sortOrder = "alpha";
      setRules(loadedRules);
      if (r[4] && r[4]._date === today()) {
        setTs(r[4]);
      } else if (r[4] && r[4]._date && r[4]._date !== today()) {
        // Stale mm2-today from a previous ordering date — wipe it so old
        // kid submissions don't bleed into the new day's doc
        try { await sSet(SK.today, { _date: today() }); } catch (e) { console.error("stale today wipe failed", e); }
      }
      // Daily reset is handled by the dailyReset Cloud Function at 8 AM Eastern
      var loadedSet = r[6] || DEF_SET;
      setSettings(loadedSet);
      // Check for deep link via URL param
      var params = new URLSearchParams(window.location.search);
      // One-time trust link (?unlock=<pin>). Compared against the freshly loaded
      // settings, not React state. A wrong value is silently ignored.
      var unlock = params.get("unlock");
      if (unlock && loadedSet.password && unlock === loadedSet.password) trustDevice(loadedSet.password);
      var startView = params.get("view");
      if (startView && ["kiosk", "inv", "dash", "grocery", "history", "set"].indexOf(startView) >= 0) {
        setView(startView);
      } else {
        setView("home");
      }
      // Scrub the query string so neither a deep link nor the PIN lingers in the address bar or history
      if (window.location.search && window.history.replaceState) window.history.replaceState({}, "", window.location.pathname);
    })();
  }, []);

  // The load-time staleness check only runs on mount, but the kiosk iPad can
  // keep one session alive for days. Re-check when the ordering date rolls
  // over so yesterday's selections never merge into a new day's doc.
  useEffect(function () {
    function checkStale() {
      var od = today();
      // Rollover: the kiosk is keyed on orderingDate, so an in-progress order
      // from the previous day remounts back at the pick screen
      setOrderingDate(function (prev) { return prev === od ? prev : od; });
      setTs(function (prev) {
        if (prev && prev._date && prev._date !== od) {
          sSet(SK.today, { _date: od }).catch(logSaveFail("sweeper wipe"));
          return {};
        }
        return prev;
      });
    }
    var iv = setInterval(checkStale, 60000);
    document.addEventListener("visibilitychange", checkStale);
    return function () { clearInterval(iv); document.removeEventListener("visibilitychange", checkStale); };
  }, []);

  // Kiosk zoom prevention: iOS ignores the viewport's user-scalable hint, so
  // block pinch gestures and double-tap zoom at the document level. Text
  // fields are exempt from the double-tap guard so typing keeps working.
  var lastTouchEnd = useRef(0);
  useEffect(function () {
    function block(e) { e.preventDefault(); }
    function onTouchMove(e) { if (e.scale !== undefined && e.scale !== 1) e.preventDefault(); }
    function onTouchEnd(e) {
      var tag = e.target && e.target.tagName ? e.target.tagName.toLowerCase() : "";
      var isField = tag === "input" || tag === "select" || tag === "textarea";
      var now = Date.now();
      if (!isField && now - lastTouchEnd.current < 300) e.preventDefault();
      lastTouchEnd.current = now;
    }
    var opts = { passive: false };
    document.addEventListener("gesturestart", block, opts);
    document.addEventListener("gesturechange", block, opts);
    document.addEventListener("gestureend", block, opts);
    document.addEventListener("touchmove", onTouchMove, opts);
    document.addEventListener("touchend", onTouchEnd, opts);
    return function () {
      document.removeEventListener("gesturestart", block);
      document.removeEventListener("gesturechange", block);
      document.removeEventListener("gestureend", block);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", onTouchEnd);
    };
  }, []);

  // Settings-type saves are fire-and-forget from many UI paths, so they log
  // failures here. saveTs/saveHist stay throwing: submitSel needs to know when
  // an order didn't persist.
  var saveMenu = useCallback(async function (m) { setMenu(m); await sSet(SK.menu, m).catch(logSaveFail("menu")); }, []);
  var saveKids = useCallback(async function (k) { setKids(k); await sSet(SK.kids, k).catch(logSaveFail("kids")); }, []);
  var saveRules = useCallback(async function (r) { setRules(r); await sSet(SK.rules, r).catch(logSaveFail("rules")); }, []);
  var saveNotif = useCallback(async function (n) { setNotif(n); await sSet(SK.notif, n).catch(logSaveFail("notif")); }, []);
  var saveSett = useCallback(async function (s) { setSettings(s); await sSet(SK.set, s).catch(logSaveFail("settings")); }, []);
  var saveCal = useCallback(async function (c) { setCalendar(c); await sSet(SK.cal, c).catch(logSaveFail("calendar")); }, []);
  var saveHist = useCallback(async function (h) { setHist(h); await sSet(SK.hist, h); }, []);
  var saveTs = useCallback(async function (t) { var w = Object.assign({}, t, { _date: today() }); setTs(w); await sSet(SK.today, w); }, []);

  var togDay = useCallback(async function () {
    var newEnabled = !settings.dayEnabled;
    var s = Object.assign({}, settings, { dayEnabled: newEnabled, _date: today(), _resetDate: realToday() });
    setSettings(s); await sSet(SK.set, s).catch(logSaveFail("settings"));
    if (notif.haEnabled && notif.haUrl) haSend(notif.haUrl, "meal_menu_orders_status", { enabled: newEnabled });
  }, [settings, notif]);
  var togSpec = useCallback(async function () { var s = Object.assign({}, settings, { specialDay: !settings.specialDay, _date: today(), _resetDate: realToday() }); setSettings(s); await sSet(SK.set, s).catch(logSaveFail("settings")); }, [settings]);

  var resetToday = useCallback(async function () { setTs({}); await sSet(SK.today, { _date: today() }).catch(logSaveFail("reset")); }, []);

  var deleteHistDay = useCallback(async function (date) {
    var newH = Object.assign({}, hist);
    Object.keys(newH).forEach(function (kidId) {
      if (Array.isArray(newH[kidId])) {
        newH[kidId] = newH[kidId].filter(function (e) { return e.date !== date; });
      }
    });
    await saveHist(newH).catch(logSaveFail("history"));
  }, [hist, saveHist]);

  var deleteKidOrder = useCallback(async function (kidId) {
    try {
      var newT = Object.assign({}, freshTs(ts));
      delete newT[kidId];
      await saveTs(newT);
      // Also remove from today's history
      var newH = Object.assign({}, hist);
      if (Array.isArray(newH[kidId])) {
        newH[kidId] = newH[kidId].filter(function (e) { return e.date !== today(); });
      }
      await saveHist(newH);
    } catch (e) { console.error("delete order failed", e); }
  }, [ts, hist, saveTs, saveHist]);

  // Resolves true only when HA acknowledged the webhook
  var sendNudge = useCallback(async function (kidId) {
    var kid = kids.find(function (k) { return k.id === kidId; });
    if (!kid || !notif.haEnabled || !notif.haUrl) return false;
    return haSend(notif.haUrl, "meal_menu_nudge", { kid_name: kid.name, kid_emoji: kid.emoji, message: kid.name + " wants to order!" });
  }, [kids, notif]);

  var submitSel = useCallback(async function (kidId, sel) {
    var base = freshTs(ts);
    var isUpd = !!base[kidId];
    // afterSchool is stored only when the kid actually picked one (activity days)
    var hasAs = !!(sel.afterSchool && sel.afterSchool.length);
    var entry = { breakfast: sel.breakfast, lunch: sel.lunch, snacks: sel.snacks, completedAt: new Date().toISOString(), updated: isUpd };
    if (hasAs) entry.afterSchool = sel.afterSchool;
    var newT = Object.assign({}, base); newT[kidId] = entry;
    await saveTs(newT);
    var kh = (hist[kidId] || []).filter(function (e) { return e.date !== today(); });
    var hEntry = { date: today(), breakfast: sel.breakfast, lunch: sel.lunch, snacks: sel.snacks };
    if (hasAs) hEntry.afterSchool = sel.afterSchool;
    var newH = Object.assign({}, hist); newH[kidId] = kh.concat([hEntry]);
    await saveHist(newH);
    setConfetti(true); if (notif.soundEnabled) playOk(); setTimeout(function () { setConfetti(false); }, 2500);
    var kid = kids.find(function (k) { return k.id === kidId; });
    if (notif.haEnabled && notif.haUrl) {
      if (notif.notifyPerKid && kid) {
        var payload = { kid_name: kid.name, updated: isUpd, breakfast: sel.breakfast, lunch: sel.lunch, snacks: sel.snacks };
        if (hasAs) payload.after_school = sel.afterSchool;
        haSend(notif.haUrl, "meal_menu_kid_done", payload);
      }
    }
  }, [ts, hist, saveTs, saveHist, notif, kids]);

  var specInfo = specDayInfo(calendar, settings.specialDay);
  var spec = !!specInfo;
  // Views only ever see today's orders; the raw ts state may lag the sweeper by up to a minute
  var tsFresh = freshTs(ts);

  if (view === "loading") return (<div style={S.loadScreen}><div style={{ fontSize: 48, animation: "bounce .6s infinite alternate" }}>🍳</div><style>{"@keyframes bounce{from{transform:translateY(0)}to{transform:translateY(-12px)}}"}</style></div>);

  return (<div style={S.app}>
    <Confetti active={confetti} />
    <style>{CSS}</style>
    {view === "home" && <Home kids={kids} ts={tsFresh} settings={settings} isSpec={spec} go={setView} />}
    {view === "kiosk" && <Kiosk key={orderingDate} kids={kids} menu={menu} rules={rules} hist={hist} ts={tsFresh} calendar={calendar} onSubmit={submitSel} dayOn={settings.dayEnabled} isSpec={spec} specInfo={specInfo} onNudge={sendNudge} onBack={function () { setView("home"); }} snd={notif.soundEnabled} />}
    {view === "inv" && <PwGate pw={settings.password} onBack={function () { setView("home"); }}><Inv menu={menu} onSave={saveMenu} settings={settings} onTogDay={togDay} onTogSpec={togSpec} isSpec={spec} onResetToday={resetToday} kids={kids} onBack={function () { setView("home"); }} /></PwGate>}
    {view === "dash" && <Dash kids={kids} ts={tsFresh} onDeleteKidOrder={deleteKidOrder} onBack={function () { setView("home"); }} saveTs={saveTs} menu={menu} calendar={calendar} />}
    {view === "grocery" && <Grocery menu={menu} onSave={saveMenu} onBack={function () { setView("home"); }} />}
    {view === "history" && <History kids={kids} hist={hist} menu={menu} onDeleteDay={deleteHistDay} onBack={function () { setView("home"); }} />}
    {view === "set" && <PwGate pw={settings.password} onBack={function () { setView("home"); }}><Sett kids={kids} rules={rules} notif={notif} settings={settings} calendar={calendar} menu={menu} saveKids={saveKids} saveRules={saveRules} saveNotif={saveNotif} saveSettings={saveSett} saveCalendar={saveCal} onBack={function () { setView("home"); }} /></PwGate>}
  </div>);
}
